import * as echarts from 'echarts' 
import {useEffect} from 'react'
import 'echarts-gl';

export default function ThreeDBar() {
  useEffect(() => {
    var ThreeDBar;
    if (ThreeDBar !== null && ThreeDBar !== undefined && ThreeDBar !== ''){
      ThreeDBar.dispose();
    }
    
    var dom = document.getElementById('ThreeDBar');
    ThreeDBar = echarts.init(dom);


    // set data
    var year = ["0", "1981", "1982", "1983", "1984", "1985", "1986", "1987", "1988", "1989", "1990"];
    var date = ["0", "1/1","1/2", "1/3", "1/4", "1/5", "1/6", "1/7", "1/8", "1/9", "1/10", "1/11", "1/12", "1/13", "1/14", "1/15", "1/16", "1/17", "1/18", "1/19", "1/20", "1/21", "1/22", "1/23", "1/24", "1/25", "1/26", "1/27", "1/28", "1/29", "1/30", "1/31",
               "2/1", "2/2", "2/3", "2/4", "2/5", "2/6", "2/7", "2/8", "2/9", "2/10", "2/11", "2/12", "2/13", "2/14", "2/15", "2/16", "2/17", "2/18", "2/19", "2/20", "2/21", "2/22", "2/23", "2/24", "2/25", "2/26", "2/27", "2/28",
               "3/1", "3/2", "3/3", "3/4", "3/5", "3/6", "3/7", "3/8", "3/9", "3/10", "3/11", "3/12", "3/13", "3/14", "3/15", "3/16", "3/17", "3/18", "3/19", "3/20", "3/21", "3/22", "3/23", "3/24", "3/25", "3/26", "3/27", "3/28", "3/29", "3/30", "3/31",
               "4/1", "4/2", "4/3", "4/4", "4/5", "4/6", "4/7", "4/8", "4/9", "4/10", "4/11", "4/12", "4/13", "4/14", "4/15", "4/16", "4/17", "4/18", "4/19", "4/20", "4/21", "4/22", "4/23", "4/24", "4/25", "4/26", "4/27", "4/28", "4/29", "4/30",
               "5/1", "5/2", "5/3", "5/4", "5/5", "5/6", "5/7", "5/8", "5/9", "5/10", "5/11", "5/12", "5/13", "5/14", "5/15", "5/16", "5/17", "5/18", "5/19", "5/20", "5/21", "5/22", "5/23", "5/24", "5/25", "5/26", "5/27", "5/28", "5/29", "5/30", "5/31",
               "6/1", "6/2", "6/3", "6/4", "6/5", "6/6", "6/7", "6/8", "6/9", "6/10", "6/11", "6/12", "6/13", "6/14", "6/15", "6/16", "6/17", "6/18", "6/19", "6/20", "6/21", "6/22", "6/23", "6/24", "6/25", "6/26", "6/27", "6/28", "6/29", "6/30",
               "7/1", "7/2", "7/3", "7/4", "7/5", "7/6", "7/7", "7/8", "7/9", "7/10", "7/11", "7/12", "7/13", "7/14", "7/15", "7/16", "7/17", "7/18", "7/19", "7/20", "7/21", "7/22", "7/23", "7/24", "7/25", "7/26", "7/27", "7/28", "7/29", "7/30", "7/31",
               "8/1", "8/2", "8/3", "8/4", "8/5", "8/6", "8/7", "8/8", "8/9", "8/10", "8/11", "8/12", "8/13", "8/14", "8/15", "8/16", "8/17", "8/18", "8/19", "8/20", "8/21", "8/22", "8/23", "8/24", "8/25", "8/26", "8/27", "8/28", "8/29", "8/30", "8/31",
               "9/1", "9/2", "9/3", "9/4", "9/5", "9/6", "9/7", "9/8", "9/9", "9/10", "9/11", "9/12", "9/13", "9/14", "9/15", "9/16", "9/17", "9/18", "9/19", "9/20", "9/21", "9/22", "9/23", "9/24", "9/25", "9/26", "9/27", "9/28", "9/29", "9/30",
               "10/1", "10/2", "10/3", "10/4", "10/5", "10/6", "10/7", "10/8", "10/9", "10/10", "10/11", "10/12", "10/13", "10/14", "10/15", "10/16", "10/17", "10/18", "10/19", "10/20", "10/21", "10/22", "10/23", "10/24", "10/25", "10/26", "10/27", "10/28", "10/29", "10/30", "10/31",
               "11/1", "11/2", "11/3", "11/4", "11/5", "11/6", "11/7", "11/8", "11/9", "11/10", "11/11", "11/12", "11/13", "11/14", "11/15", "11/16", "11/17", "11/18", "11/19", "11/20", "11/21", "11/22", "11/23", "11/24", "11/25", "11/26", "11/27", "11/28", "11/29", "11/30",
               "12/1", "12/2", "12/3", "12/4", "12/5", "12/6", "12/7", "12/8", "12/9", "12/10", "12/11", "12/12", "12/13", "12/14", "12/15", "12/16", "12/17", "12/18", "12/19", "12/20", "12/21", "12/22", "12/23", "12/24", "12/25", "12/26", "12/27", "12/28", "12/29", "12/30", "12/31"];
    var data = [
      [1, 1, 20.7],
      [1, 2, 17.9],
      [1, 3, 18.8],
      [1, 4, 14.6],
      [1, 5, 15.8],
      [1, 6, 15.8],
      [1, 7, 15.8],
      [1, 8, 17.4],
      [1, 9, 21.8],
      [1, 10, 20.0],
      [1, 11, 16.2],
      [1, 12, 13.3],
      [1, 13, 16.7],
      [1, 14, 21.5],
      [1, 15, 25.0],
      [1, 16, 20.7],
      [1, 17, 20.6],
      [1, 18, 24.8],
      [1, 19, 17.7],
      [1, 20, 15.5],
      [1, 21, 18.2],
      [1, 22, 12.1],
      [1, 23, 14.4],
      [1, 24, 16.0],
      [1, 25, 16.5],
      [1, 26, 18.7],
      [1, 27, 19.4],
      [1, 28, 17.2],
      [1, 29, 15.5],
      [1, 30, 15.1],
      [1, 31, 15.4],
      [1, 32, 15.3],
      [1, 33, 18.8],
      [1, 34, 21.9],
      [1, 35, 19.9],
      [1, 36, 16.6],
      [1, 37, 16.8],
      [1, 38, 14.6],
      [1, 39, 17.1],
      [1, 40, 25.0],
      [1, 41, 15.0],
      [1, 42, 13.7],
      [1, 43, 13.9],
      [1, 44, 18.3],
      [1, 45, 22.0],
      [1, 46, 22.1],
      [1, 47, 21.2],
      [1, 48, 18.4],
      [1, 49, 16.6],
      [1, 50, 16.1],
      [1, 51, 15.7],
      [1, 52, 16.6],
      [1, 53, 16.5],
      [1, 54, 14.4],
      [1, 55, 14.4],
      [1, 56, 18.5],
      [1, 57, 16.9],
      [1, 58, 17.5],
      [1, 59, 21.2],
      [1, 60, 17.8],
      [1, 61, 18.6],
      [1, 62, 17.0],
      [1, 63, 16.0],
      [1, 64, 13.3],
      [1, 65, 14.3],
      [1, 66, 11.4],
      [1, 67, 16.3],
      [1, 68, 16.1],
      [1, 69, 11.8],
      [1, 70, 12.2],
      [1, 71, 14.7],
      [1, 72, 11.8],
      [1, 73, 11.3],
      [1, 74, 10.6],
      [1, 75, 11.7],
      [1, 76, 14.2],
      [1, 77, 11.2],
      [1, 78, 16.9],
      [1, 79, 16.7],
      [1, 80, 8.1],
      [1, 81, 8.0],
      [1, 82, 8.8],
      [1, 83, 13.4],
      [1, 84, 10.9],
      [1, 85, 13.4],
      [1, 86, 11.0],
      [1, 87, 15.0],
      [1, 88, 15.7],
      [1, 89, 14.5],
      [1, 90, 15.8],
      [1, 91, 16.7],
      [1, 92, 16.8],
      [1, 93, 17.5],
      [1, 94, 17.1],
      [1, 95, 18.1],
      [1, 96, 16.6],
      [1, 97, 10.0],
      [1, 98, 14.9],
      [1, 99, 15.9],
      [1, 100, 13.0],
      [1, 101, 7.6],
      [1, 102, 11.5],
      [1, 103, 13.5],
      [1, 104, 13.0],
      [1, 105, 13.3],
      [1, 106, 12.1],
      [1, 107, 12.4],
      [1, 108, 13.2],
      [1, 109, 13.8],
      [1, 110, 10.6],
      [1, 111, 9.0],
      [1, 112, 10.0],
      [1, 113, 9.8],
      [1, 114, 11.5],
      [1, 115, 8.9],
      [1, 116, 7.4],
      [1, 117, 9.9],
      [1, 118, 9.3],
      [1, 119, 9.9],
      [1, 120, 7.4],
      [1, 121, 8.6],
      [1, 122, 11.9],
      [1, 123, 14.0],
      [1, 124, 8.6],
      [1, 125, 10.0],
      [1, 126, 13.5],
      [1, 127, 12.0],
      [1, 128, 10.5],
      [1, 129, 10.7],
      [1, 130, 8.1],
      [1, 131, 10.1],
      [1, 132, 10.6],
      [1, 133, 5.3],
      [1, 134, 6.6],
      [1, 135, 8.5],
      [1, 136, 11.2],
      [1, 137, 9.8],
      [1, 138, 5.9],
      [1, 139, 3.2],
      [1, 140, 2.1],
      [1, 141, 3.4],
      [1, 142, 5.4],
      [1, 143, 9.6],
      [1, 144, 11.5],
      [1, 145, 12.3],
      [1, 146, 12.6],
      [1, 147, 11.0],
      [1, 148, 11.2],
      [1, 149, 11.4],
      [1, 150, 11.8],
      [1, 151, 12.8],
      [1, 152, 11.6],
      [1, 153, 10.6],
      [1, 154, 9.8],
      [1, 155, 11.2],
      [1, 156, 5.7],
      [1, 157, 7.1],
      [1, 158, 2.5],
      [1, 159, 3.5],
      [1, 160, 4.6],
      [1, 161, 11.0],
      [1, 162, 5.7],
      [1, 163, 7.7],
      [1, 164, 10.4],
      [1, 165, 11.4],
      [1, 166, 9.2],
      [1, 167, 6.1],
      [1, 168, 2.7],
      [1, 169, 4.3],
      [1, 170, 6.3],
      [1, 171, 3.8],
      [1, 172, 4.4],
      [1, 173, 7.1],
      [1, 174, 4.8],
      [1, 175, 5.8],
      [1, 176, 6.2],
      [1, 177, 7.3],
      [1, 178, 9.2],
      [1, 179, 10.2],
      [1, 180, 9.5],
      [1, 181, 9.5],
      [1, 182, 10.7],
      [1, 183, 10.0],
      [1, 184, 6.5],
      [1, 185, 7.0],
      [1, 186, 7.4],
      [1, 187, 8.1],
      [1, 188, 6.6],
      [1, 189, 8.3],
      [1, 190, 8.9],
      [1, 191, 4.6],
      [1, 192, 6.8],
      [1, 193, 5.7],
      [1, 194, 6.1],
      [1, 195, 7.0],
      [1, 196, 7.2],
      [1, 197, 6.3],
      [1, 198, 8.8],
      [1, 199, 5.0],
      [1, 200, 7.4],
      [1, 201, 10.1],
      [1, 202, 12.0],
      [1, 203, 9.0],
      [1, 204, 8.9],
      [1, 205, 9.8],
      [1, 206, 9.0],
      [1, 207, 9.2],
      [1, 208, 7.7],
      [1, 209, 8.0],
      [1, 210, 6.1],
      [1, 211, 3.5],
      [1, 212, 3.2],
      [1, 213, 5.7],
      [1, 214, 7.7],
      [1, 215, 9.0],
      [1, 216, 10.0],
      [1, 217, 6.2],
      [1, 218, 6.9],
      [1, 219, 6.5],
      [1, 220, 6.8],
      [1, 221, 7.0],
      [1, 222, 5.2],
      [1, 223, 3.0],
      [1, 224, 5.6],
      [1, 225, 7.9],
      [1, 226, 9.0],
      [1, 227, 8.6],
      [1, 228, 10.3],
      [1, 229, 10.5],
      [1, 230, 7.6],
      [1, 231, 9.7],
      [1, 232, 12.5],
      [1, 233, 7.4],
      [1, 234, 7.9],
      [1, 235, 3.9],
      [1, 236, 6.6],
      [1, 237, 4.6],
      [1, 238, 7.0],
      [1, 239, 6.0],
      [1, 240, 5.5],
      [1, 241, 8.1],
      [1, 242, 5.5],
      [1, 243, 6.2],
      [1, 244, 8.0],
      [1, 245, 10.3],
      [1, 246, 9.8],
      [1, 247, 9.6],
      [1, 248, 8.5],
      [1, 249, 7.5],
      [1, 250, 11.2],
      [1, 251, 14.6],
      [1, 252, 11.7],
      [1, 253, 7.8],
      [1, 254, 12.3],
      [1, 255, 10.1],
      [1, 256, 11.5],
      [1, 257, 7.3],
      [1, 258, 10.9],
      [1, 259, 14.1],
      [1, 260, 10.7],
      [1, 261, 16.9],
      [1, 262, 10.5],
      [1, 263, 6.5],
      [1, 264, 11.0],
      [1, 265, 6.3],
      [1, 266, 10.5],
      [1, 267, 7.2],
      [1, 268, 7.6],
      [1, 269, 10.7],
      [1, 270, 7.8],
      [1, 271, 9.6],
      [1, 272, 11.4],
      [1, 273, 12.4],
      [1, 274, 8.9],
      [1, 275, 13.2],
      [1, 276, 8.6],
      [1, 277, 6.2],
      [1, 278, 11.4],
      [1, 279, 13.2],
      [1, 280, 14.3],
      [1, 281, 7.3],
      [1, 282, 12.9],
      [1, 283, 7.8],
      [1, 284, 6.2],
      [1, 285, 5.6],
      [1, 286, 10.0],
      [1, 287, 13.3],
      [1, 288, 8.3],
      [1, 289, 10.2],
      [1, 290, 8.6],
      [1, 291, 7.3],
      [1, 292, 10.4],
      [1, 293, 11.2],
      [1, 294, 13.2],
      [1, 295, 11.4],
      [1, 296, 9.1],
      [1, 297, 6.6],
      [1, 298, 8.4],
      [1, 299, 9.7],
      [1, 300, 13.2],
      [1, 301, 12.5],
      [1, 302, 11.0],
      [1, 303, 11.0],
      [1, 304, 11.7],
      [1, 305, 9.2],
      [1, 306, 11.5],
      [1, 307, 13.6],
      [1, 308, 13.7],
      [1, 309, 10.4],
      [1, 310, 11.5],
      [1, 311, 7.6],
      [1, 312, 9.6],
      [1, 313, 14.2],
      [1, 314, 15.7],
      [1, 315, 10.5],
      [1, 316, 10.5],
      [1, 317, 9.7],
      [1, 318, 9.5],
      [1, 319, 11.3],
      [1, 320, 8.9],
      [1, 321, 9.4],
      [1, 322, 11.9],
      [1, 323, 11.7],
      [1, 324, 13.4],
      [1, 325, 12.6],
      [1, 326, 10.1],
      [1, 327, 15.8],
      [1, 328, 13.6],
      [1, 329, 11.9],
      [1, 330, 9.9],
      [1, 331, 12.6],
      [1, 332, 17.8],
      [1, 333, 15.0],
      [1, 334, 13.6],
      [1, 335, 13.4],
      [1, 336, 10.5],
      [1, 337, 14.2],
      [1, 338, 11.5],
      [1, 339, 13.0],
      [1, 340, 15.0],
      [1, 341, 14.7],
      [1, 342, 12.6],
      [1, 343, 12.5],
      [1, 344, 13.5],
      [1, 345, 14.8],
      [1, 346, 17.2],
      [1, 347, 9.7],
      [1, 348, 12.1],
      [1, 349, 12.8],
      [1, 350, 11.2],
      [1, 351, 16.4],
      [1, 352, 15.6],
      [1, 353, 13.3],
      [1, 354, 11.0],
      [1, 355, 11.1],
      [1, 356, 15.0],
      [1, 357, 12.8],
      [1, 358, 15.0],
      [1, 359, 14.2],
      [1, 360, 14.0],
      [1, 361, 15.5],
      [1, 362, 13.3],
      [1, 363, 15.6],
      [1, 364, 15.2],
      [1, 365, 17.4],
      [2, 1, 17.0],
      [2, 2, 15.0],
      [2, 3, 13.5],
      [2, 4, 15.2],
      [2, 5, 13.0],
      [2, 6, 12.5],
      [2, 7, 14.1],
      [2, 8, 14.8],
      [2, 9, 16.2],
      [2, 10, 15.8],
      [2, 11, 19.1],
      [2, 12, 22.2],
      [2, 13, 15.9],
      [2, 14, 13.0],
      [2, 15, 14.1],
      [2, 16, 15.8],
      [2, 17, 24.0],
      [2, 18, 18.0],
      [2, 19, 19.7],
      [2, 20, 25.2],
      [2, 21, 20.5],
      [2, 22, 19.3],
      [2, 23, 15.8],
      [2, 24, 17.0],
      [2, 25, 18.4],
      [2, 26, 13.3],
      [2, 27, 14.6],
      [2, 28, 12.5],
      [2, 29, 17.0],
      [2, 30, 17.1],
      [2, 31, 14.0],
      [2, 32, 14.6],
      [2, 33, 13.3],
      [2, 34, 14.8],
      [2, 35, 15.1],
      [2, 36, 13.1],
      [2, 37, 13.6],
      [2, 38, 19.5],
      [2, 39, 22.7],
      [2, 40, 17.2],
      [2, 41, 13.5],
      [2, 42, 15.4],
      [2, 43, 17.0],
      [2, 44, 19.2],
      [2, 45, 22.8],
      [2, 46, 26.3],
      [2, 47, 18.2],
      [2, 48, 17.0],
      [2, 49, 14.8],
      [2, 50, 12.8],
      [2, 51, 15.5],
      [2, 52, 15.6],
      [2, 53, 13.1],
      [2, 54, 15.2],
      [2, 55, 14.1],
      [2, 56, 12.5],
      [2, 57, 14.6],
      [2, 58, 10.4],
      [2, 59, 13.9],
      [2, 60, 11.9],
      [2, 61, 13.5],
      [2, 62, 9.8],
      [2, 63, 14.0],
      [2, 64, 21.5],
      [2, 65, 19.5],
      [2, 66, 16.7],
      [2, 67, 19.1],
      [2, 68, 11.0],
      [2, 69, 9.0],
      [2, 70, 10.0],
      [2, 71, 14.6],
      [2, 72, 12.5],
      [2, 73, 17.2],
      [2, 74, 19.2],
      [2, 75, 22.2],
      [2, 76, 15.7],
      [2, 77, 14.2],
      [2, 78, 9.8],
      [2, 79, 14.0],
      [2, 80, 17.5],
      [2, 81, 20.7],
      [2, 82, 15.6],
      [2, 83, 13.2],
      [2, 84, 14.5],
      [2, 85, 16.8],
      [2, 86, 17.2],
      [2, 87, 13.4],
      [2, 88, 14.2],
      [2, 89, 14.3],
      [2, 90, 10.2],
      [2, 91, 10.4],
      [2, 92, 12.3],
      [2, 93, 11.9],
      [2, 94, 11.2],
      [2, 95, 8.5],
      [2, 96, 12.0],
      [2, 97, 12.4],
      [2, 98, 12.9],
      [2, 99, 10.1],
      [2, 100, 15.0],
      [2, 101, 13.6],
      [2, 102, 12.4],
      [2, 103, 13.6],
      [2, 104, 16.1],
      [2, 105, 19.5],
      [2, 106, 14.2],
      [2, 107, 9.3],
      [2, 108, 10.1],
      [2, 109, 7.4],
      [2, 110, 8.6],
      [2, 111, 7.8],
      [2, 112, 9.1],
      [2, 113, 13.0],
      [2, 114, 16.5],
      [2, 115, 12.9],
      [2, 116, 6.9],
      [2, 117, 6.9],
      [2, 118, 8.7],
      [2, 119, 10.0],
      [2, 120, 10.8],
      [2, 121, 7.5],
      [2, 122, 6.3],
      [2, 123, 11.9],
      [2, 124, 13.8],
      [2, 125, 11.8],
      [2, 126, 11.0],
      [2, 127, 10.1],
      [2, 128, 8.5],
      [2, 129, 5.5],
      [2, 130, 7.6],
      [2, 131, 8.7],
      [2, 132, 10.8],
      [2, 133, 11.2],
      [2, 134, 9.1],
      [2, 135, 3.7],
      [2, 136, 4.6],
      [2, 137, 6.6],
      [2, 138, 13.2],
      [2, 139, 15.2],
      [2, 140, 7.6],
      [2, 141, 8.4],
      [2, 142, 6.0],
      [2, 143, 8.3],
      [2, 144, 8.6],
      [2, 145, 11.1],
      [2, 146, 12.1],
      [2, 147, 12.9],
      [2, 148, 14.0],
      [2, 149, 12.5],
      [2, 150, 11.5],
      [2, 151, 7.0],
      [2, 152, 7.1],
      [2, 153, 9.0],
      [2, 154, 3.1],
      [2, 155, 2.5],
      [2, 156, 0.0],
      [2, 157, 1.6],
      [2, 158, 2.6],
      [2, 159, 5.7],
      [2, 160, 2.3],
      [2, 161, 4.5],
      [2, 162, 8.2],
      [2, 163, 6.9],
      [2, 164, 7.3],
      [2, 165, 6.0],
      [2, 166, 7.3],
      [2, 167, 7.6],
      [2, 168, 8.0],
      [2, 169, 8.0],
      [2, 170, 6.8],
      [2, 171, 7.3],
      [2, 172, 6.2],
      [2, 173, 6.9],
      [2, 174, 8.9],
      [2, 175, 4.0],
      [2, 176, 1.3],
      [2, 177, 0.8],
      [2, 178, 4.3],
      [2, 179, 7.3],
      [2, 180, 7.7],
      [2, 181, 9.0],
      [2, 182, 4.2],
      [2, 183, 1.6],
      [2, 184, 2.6],
      [2, 185, 3.4],
      [2, 186, 3.9],
      [2, 187, 7.0],
      [2, 188, 7.8],
      [2, 189, 5.3],
      [2, 190, 2.4],
      [2, 191, 2.8],
      [2, 192, 4.0],
      [2, 193, 7.5],
      [2, 194, 7.8],
      [2, 195, 5.6],
      [2, 196, 3.3],
      [2, 197, 5.0],
      [2, 198, 3.7],
      [2, 199, 3.9],
      [2, 200, 5.2],
      [2, 201, 0.2],
      [2, 202, 0.8],
      [2, 203, 0.9],
      [2, 204, 3.5],
      [2, 205, 6.6],
      [2, 206, 9.5],
      [2, 207, 9.0],
      [2, 208, 3.5],
      [2, 209, 4.5],
      [2, 210, 5.7],
      [2, 211, 5.6],
      [2, 212, 7.1],
      [2, 213, 9.7],
      [2, 214, 8.3],
      [2, 215, 9.1],
      [2, 216, 2.8],
      [2, 217, 2.2],
      [2, 218, 4.5],
      [2, 219, 3.8],
      [2, 220, 3.8],
      [2, 221, 6.2],
      [2, 222, 11.5],
      [2, 223, 10.2],
      [2, 224, 7.9],
      [2, 225, 9.0],
      [2, 226, 9.5],
      [2, 227, 6.0],
      [2, 228, 8.2],
      [2, 229, 9.2],
      [2, 230, 4.3],
      [2, 231, 6.6],
      [2, 232, 9.4],
      [2, 233, 13.2],
      [2, 234, 6.6],
      [2, 235, 5.1],
      [2, 236, 12.1],
      [2, 237, 11.2],
      [2, 238, 8.5],
      [2, 239, 4.6],
      [2, 240, 7.0],
      [2, 241, 14.2],
      [2, 242, 12.7],
      [2, 243, 7.6],
      [2, 244, 4.0],
      [2, 245, 10.0],
      [2, 246, 10.5],
      [2, 247, 5.0],
      [2, 248, 4.5],
      [2, 249, 8.2],
      [2, 250, 4.3],
      [2, 251, 9.8],
      [2, 252, 5.8],
      [2, 253, 5.0],
      [2, 254, 8.5],
      [2, 255, 9.0],
      [2, 256, 3.6],
      [2, 257, 6.7],
      [2, 258, 6.7],
      [2, 259, 10.1],
      [2, 260, 15.0],
      [2, 261, 8.9],
      [2, 262, 5.7],
      [2, 263, 4.2],
      [2, 264, 4.0],
      [2, 265, 5.3],
      [2, 266, 6.3],
      [2, 267, 8.5],
      [2, 268, 11.5],
      [2, 269, 7.7],
      [2, 270, 9.2],
      [2, 271, 7.8],
      [2, 272, 6.3],
      [2, 273, 6.3],
      [2, 274, 8.6],
      [2, 275, 6.1],
      [2, 276, 13.2],
      [2, 277, 9.9],
      [2, 278, 4.7],
      [2, 279, 5.8],
      [2, 280, 14.9],
      [2, 281, 10.7],
      [2, 282, 8.6],
      [2, 283, 9.4],
      [2, 284, 5.7],
      [2, 285, 10.9],
      [2, 286, 13.1],
      [2, 287, 10.4],
      [2, 288, 8.2],
      [2, 289, 9.8],
      [2, 290, 7.5],
      [2, 291, 5.8],
      [2, 292, 9.8],
      [2, 293, 7.9],
      [2, 294, 8.7],
      [2, 295, 10.0],
      [2, 296, 10.6],
      [2, 297, 8.0],
      [2, 298, 10.2],
      [2, 299, 15.1],
      [2, 300, 13.9],
      [2, 301, 9.2],
      [2, 302, 9.0],
      [2, 303, 13.2],
      [2, 304, 7.0],
      [2, 305, 10.6],
      [2, 306, 6.9],
      [2, 307, 9.5],
      [2, 308, 12.5],
      [2, 309, 13.6],
      [2, 310, 17.7],
      [2, 311, 16.0],
      [2, 312, 11.3],
      [2, 313, 10.5],
      [2, 314, 14.4],
      [2, 315, 10.3],
      [2, 316, 9.0],
      [2, 317, 11.1],
      [2, 318, 14.5],
      [2, 319, 18.0],
      [2, 320, 12.8],
      [2, 321, 10.7],
      [2, 322, 9.1],
      [2, 323, 8.7],
      [2, 324, 12.4],
      [2, 325, 12.6],
      [2, 326, 10.3],
      [2, 327, 13.7],
      [2, 328, 16.0],
      [2, 329, 15.8],
      [2, 330, 12.1],
      [2, 331, 12.5],
      [2, 332, 12.2],
      [2, 333, 13.7],
      [2, 334, 16.1],
      [2, 335, 15.5],
      [2, 336, 10.3],
      [2, 337, 10.5],
      [2, 338, 11.0],
      [2, 339, 11.9],
      [2, 340, 13.0],
      [2, 341, 12.2],
      [2, 342, 10.6],
      [2, 343, 13.0],
      [2, 344, 13.0],
      [2, 345, 12.2],
      [2, 346, 12.6],
      [2, 347, 18.7],
      [2, 348, 15.2],
      [2, 349, 15.3],
      [2, 350, 13.9],
      [2, 351, 15.8],
      [2, 352, 13.0],
      [2, 353, 13.0],
      [2, 354, 13.7],
      [2, 355, 12.0],
      [2, 356, 10.8],
      [2, 357, 15.6],
      [2, 358, 15.3],
      [2, 359, 13.9],
      [2, 360, 13.0],
      [2, 361, 15.3],
      [2, 362, 16.3],
      [2, 363, 15.8],
      [2, 364, 17.7],
      [2, 365, 16.3],
      [3, 1, 18.4],
      [3, 2, 15.0],
      [3, 3, 10.9],
      [3, 4, 11.4],
      [3, 5, 14.8],
      [3, 6, 12.1],
      [3, 7, 12.8],
      [3, 8, 16.2],
      [3, 9, 15.5],
      [3, 10, 13.0],
      [3, 11, 10.5],
      [3, 12, 9.1],
      [3, 13, 10.5],
      [3, 14, 11.8],
      [3, 15, 12.7],
      [3, 16, 12.7],
      [3, 17, 11.5],
      [3, 18, 13.8],
      [3, 19, 13.3],
      [3, 20, 11.6],
      [3, 21, 15.4],
      [3, 22, 12.4],
      [3, 23, 16.9],
      [3, 24, 14.7],
      [3, 25, 10.6],
      [3, 26, 15.6],
      [3, 27, 10.7],
      [3, 28, 12.6],
      [3, 29, 13.8],
      [3, 30, 14.3],
      [3, 31, 14.0],
      [3, 32, 18.1],
      [3, 33, 17.3],
      [3, 34, 13.0],
      [3, 35, 16.0],
      [3, 36, 14.9],
      [3, 37, 16.2],
      [3, 38, 20.3],
      [3, 39, 22.5],
      [3, 40, 17.2],
      [3, 41, 15.9],
      [3, 42, 16.8],
      [3, 43, 13.8],
      [3, 44, 12.8],
      [3, 45, 14.0],
      [3, 46, 17.5],
      [3, 47, 21.5],
      [3, 48, 16.8],
      [3, 49, 13.6],
      [3, 50, 14.5],
      [3, 51, 14.2],
      [3, 52, 15.7],
      [3, 53, 19.7],
      [3, 54, 17.4],
      [3, 55, 14.4],
      [3, 56, 16.9],
      [3, 57, 19.1],
      [3, 58, 20.4],
      [3, 59, 20.1],
      [3, 60, 19.9],
      [3, 61, 22.0],
      [3, 62, 20.5],
      [3, 63, 22.1],
      [3, 64, 20.6],
      [3, 65, 15.0],
      [3, 66, 20.6],
      [3, 67, 21.5],
      [3, 68, 16.2],
      [3, 69, 14.1],
      [3, 70, 14.5],
      [3, 71, 21.1],
      [3, 72, 15.9],
      [3, 73, 15.2],
      [3, 74, 13.1],
      [3, 75, 13.2],
      [3, 76, 12.5],
      [3, 77, 15.2],
      [3, 78, 17.6],
      [3, 79, 15.5],
      [3, 80, 16.7],
      [3, 81, 16.3],
      [3, 82, 15.1],
      [3, 83, 12.7],
      [3, 84, 10.0],
      [3, 85, 11.4],
      [3, 86, 12.6],
      [3, 87, 10.7],
      [3, 88, 10.0],
      [3, 89, 13.9],
      [3, 90, 13.4],
      [3, 91, 12.5],
      [3, 92, 12.8],
      [3, 93, 7.8],
      [3, 94, 11.1],
      [3, 95, 10.7],
      [3, 96, 7.1],
      [3, 97, 6.7],
      [3, 98, 5.7],
      [3, 99, 9.1],
      [3, 100, 15.2],
      [3, 101, 15.5],
      [3, 102, 11.1],
      [3, 103, 11.7],
      [3, 104, 11.5],
      [3, 105, 9.8],
      [3, 106, 6.2],
      [3, 107, 6.7],
      [3, 108, 7.5],
      [3, 109, 8.8],
      [3, 110, 8.0],
      [3, 111, 10.4],
      [3, 112, 14.5],
      [3, 113, 16.5],
      [3, 114, 14.1],
      [3, 115, 10.5],
      [3, 116, 12.6],
      [3, 117, 13.0],
      [3, 118, 8.7],
      [3, 119, 10.1],
      [3, 120, 12.0],
      [3, 121, 12.5],
      [3, 122, 13.5],
      [3, 123, 13.7],
      [3, 124, 13.5],
      [3, 125, 10.7],
      [3, 126, 13.0],
      [3, 127, 11.6],
      [3, 128, 13.0],
      [3, 129, 11.2],
      [3, 130, 13.5],
      [3, 131, 12.9],
      [3, 132, 6.8],
      [3, 133, 10.0],
      [3, 134, 14.5],
      [3, 135, 11.7],
      [3, 136, 6.7],
      [3, 137, 4.6],
      [3, 138, 4.9],
      [3, 139, 7.4],
      [3, 140, 8.3],
      [3, 141, 7.5],
      [3, 142, 6.2],
      [3, 143, 7.8],
      [3, 144, 13.2],
      [3, 145, 11.9],
      [3, 146, 6.5],
      [3, 147, 8.3],
      [3, 148, 12.1],
      [3, 149, 9.3],
      [3, 150, 7.5],
      [3, 151, 9.3],
      [3, 152, 11.0],
      [3, 153, 10.8],
      [3, 154, 5.3],
      [3, 155, 7.6],
      [3, 156, 5.6],
      [3, 157, 7.2],
      [3, 158, 9.6],
      [3, 159, 7.0],
      [3, 160, 8.3],
      [3, 161, 7.8],
      [3, 162, 4.7],
      [3, 163, 6.8],
      [3, 164, 7.2],
      [3, 165, 8.3],
      [3, 166, 9.5],
      [3, 167, 4.7],
      [3, 168, 3.0],
      [3, 169, 1.5],
      [3, 170, 2.5],
      [3, 171, 6.2],
      [3, 172, 11.6],
      [3, 173, 6.6],
      [3, 174, 6.6],
      [3, 175, 8.0],
      [3, 176, 7.9],
      [3, 177, 3.3],
      [3, 178, 3.9],
      [3, 179, 6.0],
      [3, 180, 4.0],
      [3, 181, 5.5],
      [3, 182, 8.5],
      [3, 183, 9.8],
      [3, 184, 9.5],
      [3, 185, 7.2],
      [3, 186, 8.1],
      [3, 187, 8.0],
      [3, 188, 8.5],
      [3, 189, 8.8],
      [3, 190, 8.3],
      [3, 191, 2.4],
      [3, 192, 4.9],
      [3, 193, 5.9],
      [3, 194, 6.7],
      [3, 195, 8.4],
      [3, 196, 6.5],
      [3, 197, 7.9],
      [3, 198, 4.1],
      [3, 199, 5.4],
      [3, 200, 7.5],
      [3, 201, 3.9],
      [3, 202, 2.5],
      [3, 203, 5.3],
      [3, 204, 6.6],
      [3, 205, 0.0],
      [3, 206, 0.7],
      [3, 207, 7.6],
      [3, 208, 12.3],
      [3, 209, 9.2],
      [3, 210, 9.6],
      [3, 211, 9.5],
      [3, 212, 10.0],
      [3, 213, 7.7],
      [3, 214, 8.0],
      [3, 215, 8.3],
      [3, 216, 8.3],
      [3, 217, 4.5],
      [3, 218, 6.5],
      [3, 219, 9.4],
      [3, 220, 9.4],
      [3, 221, 10.5],
      [3, 222, 10.7],
      [3, 223, 9.9],
      [3, 224, 7.6],
      [3, 225, 5.8],
      [3, 226, 8.5],
      [3, 227, 13.8],
      [3, 228, 14.3],
      [3, 229, 8.3],
      [3, 230, 5.3],
      [3, 231, 3.0],
      [3, 232, 5.2],
      [3, 233, 10.3],
      [3, 234, 11.1],
      [3, 235, 10.5],
      [3, 236, 9.0],
      [3, 237, 13.0],
      [3, 238, 6.4],
      [3, 239, 8.4],
      [3, 240, 6.7],
      [3, 241, 8.3],
      [3, 242, 11.2],
      [3, 243, 10.0],
      [3, 244, 10.1],
      [3, 245, 10.6],
      [3, 246, 10.9],
      [3, 247, 5.7],
      [3, 248, 9.5],
      [3, 249, 10.4],
      [3, 250, 11.1],
      [3, 251, 12.2],
      [3, 252, 10.6],
      [3, 253, 8.8],
      [3, 254, 9.2],
      [3, 255, 5.5],
      [3, 256, 7.1],
      [3, 257, 6.5],
      [3, 258, 4.3],
      [3, 259, 5.0],
      [3, 260, 11.2],
      [3, 261, 7.5],
      [3, 262, 12.0],
      [3, 263, 13.6],
      [3, 264, 8.3],
      [3, 265, 8.5],
      [3, 266, 12.9],
      [3, 267, 7.7],
      [3, 268, 7.6],
      [3, 269, 3.5],
      [3, 270, 10.4],
      [3, 271, 15.4],
      [3, 272, 10.6],
      [3, 273, 9.6],
      [3, 274, 9.3],
      [3, 275, 13.9],
      [3, 276, 7.7],
      [3, 277, 9.5],
      [3, 278, 7.6],
      [3, 279, 6.9],
      [3, 280, 6.8],
      [3, 281, 5.8],
      [3, 282, 6.0],
      [3, 283, 8.3],
      [3, 284, 9.1],
      [3, 285, 12.5],
      [3, 286, 13.2],
      [3, 287, 16.2],
      [3, 288, 12.5],
      [3, 289, 11.8],
      [3, 290, 10.6],
      [3, 291, 10.0],
      [3, 292, 12.2],
      [3, 293, 8.9],
      [3, 294, 10.3],
      [3, 295, 7.5],
      [3, 296, 11.6],
      [3, 297, 12.6],
      [3, 298, 12.9],
      [3, 299, 11.7],
      [3, 300, 14.0],
      [3, 301, 12.3],
      [3, 302, 9.0],
      [3, 303, 9.2],
      [3, 304, 9.8],
      [3, 305, 11.8],
      [3, 306, 10.6],
      [3, 307, 12.6],
      [3, 308, 11.0],
      [3, 309, 8.2],
      [3, 310, 7.5],
      [3, 311, 13.6],
      [3, 312, 14.8],
      [3, 313, 10.9],
      [3, 314, 7.7],
      [3, 315, 10.2],
      [3, 316, 10.8],
      [3, 317, 10.8],
      [3, 318, 12.5],
      [3, 319, 13.2],
      [3, 320, 8.7],
      [3, 321, 5.7],
      [3, 322, 9.8],
      [3, 323, 7.3],
      [3, 324, 10.8],
      [3, 325, 10.0],
      [3, 326, 16.2],
      [3, 327, 15.0],
      [3, 328, 14.5],
      [3, 329, 15.9],
      [3, 330, 14.9],
      [3, 331, 14.2],
      [3, 332, 15.8],
      [3, 333, 17.2],
      [3, 334, 17.6],
      [3, 335, 12.1],
      [3, 336, 11.4],
      [3, 337, 13.0],
      [3, 338, 13.2],
      [3, 339, 12.0],
      [3, 340, 15.3],
      [3, 341, 12.7],
      [3, 342, 12.1],
      [3, 343, 13.8],
      [3, 344, 10.9],
      [3, 345, 12.0],
      [3, 346, 16.5],
      [3, 347, 15.0],
      [3, 348, 11.2],
      [3, 349, 13.9],
      [3, 350, 15.0],
      [3, 351, 14.8],
      [3, 352, 15.0],
      [3, 353, 13.3],
      [3, 354, 20.4],
      [3, 355, 18.0],
      [3, 356, 12.2],
      [3, 357, 16.7],
      [3, 358, 13.8],
      [3, 359, 17.5],
      [3, 360, 15.0],
      [3, 361, 13.9],
      [3, 362, 11.1],
      [3, 363, 16.1],
      [3, 364, 20.4],
      [3, 365, 18.0],
      [4, 1, 19.5],
      [4, 2, 17.1],
      [4, 3, 17.1],
      [4, 4, 12.0],
      [4, 5, 11.0],
      [4, 6, 16.3],
      [4, 7, 16.1],
      [4, 8, 13.0],
      [4, 9, 13.4],
      [4, 10, 15.2],
      [4, 11, 12.5],
      [4, 12, 14.3],
      [4, 13, 16.5],
      [4, 14, 18.6],
      [4, 15, 18.0],
      [4, 16, 18.2],
      [4, 17, 11.4],
      [4, 18, 11.9],
      [4, 19, 12.2],
      [4, 20, 14.8],
      [4, 21, 13.1],
      [4, 22, 12.7],
      [4, 23, 10.5],
      [4, 24, 13.8],
      [4, 25, 18.8],
      [4, 26, 13.9],
      [4, 27, 11.2],
      [4, 28, 10.6],
      [4, 29, 14.7],
      [4, 30, 13.1],
      [4, 31, 12.1],
      [4, 32, 14.7],
      [4, 33, 11.1],
      [4, 34, 13.0],
      [4, 35, 15.6],
      [4, 36, 14.2],
      [4, 37, 15.5],
      [4, 38, 18.0],
      [4, 39, 15.0],
      [4, 40, 15.9],
      [4, 41, 15.5],
      [4, 42, 15.8],
      [4, 43, 16.6],
      [4, 44, 13.6],
      [4, 45, 13.8],
      [4, 46, 14.6],
      [4, 47, 15.6],
      [4, 48, 16.6],
      [4, 49, 14.3],
      [4, 50, 16.3],
      [4, 51, 18.9],
      [4, 52, 18.7],
      [4, 53, 14.5],
      [4, 54, 16.5],
      [4, 55, 14.1],
      [4, 56, 13.5],
      [4, 57, 11.7],
      [4, 58, 15.1],
      [4, 59, 11.2],
      [4, 60, 12.6],
      [4, 61, 8.8],
      [4, 62, 10.5],
      [4, 63, 12.1],
      [4, 64, 14.5],
      [4, 65, 19.5],
      [4, 66, 14.0],
      [4, 67, 13.8],
      [4, 68, 10.5],
      [4, 69, 13.8],
      [4, 70, 11.4],
      [4, 71, 15.6],
      [4, 72, 11.1],
      [4, 73, 12.1],
      [4, 74, 14.2],
      [4, 75, 10.9],
      [4, 76, 14.2],
      [4, 77, 13.8],
      [4, 78, 15.1],
      [4, 79, 14.0],
      [4, 80, 12.1],
      [4, 81, 13.8],
      [4, 82, 16.6],
      [4, 83, 17.8],
      [4, 84, 9.4],
      [4, 85, 10.2],
      [4, 86, 7.4],
      [4, 87, 8.7],
      [4, 88, 14.0],
      [4, 89, 15.3],
      [4, 90, 11.1],
      [4, 91, 9.7],
      [4, 92, 10.3],
      [4, 93, 9.2],
      [4, 94, 8.2],
      [4, 95, 9.7],
      [4, 96, 12.4],
      [4, 97, 12.5],
      [4, 98, 9.0],
      [4, 99, 9.7],
      [4, 100, 10.1],
      [4, 101, 11.2],
      [4, 102, 12.0],
      [4, 103, 11.1],
      [4, 104, 10.8],
      [4, 105, 12.8],
      [4, 106, 9.8],
      [4, 107, 13.7],
      [4, 108, 11.0],
      [4, 109, 13.2],
      [4, 110, 13.0],
      [4, 111, 10.2],
      [4, 112, 13.2],
      [4, 113, 9.3],
      [4, 114, 11.1],
      [4, 115, 10.3],
      [4, 116, 8.7],
      [4, 117, 11.7],
      [4, 118, 12.5],
      [4, 119, 6.5],
      [4, 120, 9.6],
      [4, 121, 13.8],
      [4, 122, 14.7],
      [4, 123, 9.1],
      [4, 124, 4.8],
      [4, 125, 3.3],
      [4, 126, 3.5],
      [4, 127, 5.7],
      [4, 128, 5.5],
      [4, 129, 7.0],
      [4, 130, 9.5],
      [4, 131, 9.9],
      [4, 132, 4.9],
      [4, 133, 6.3],
      [4, 134, 4.8],
      [4, 135, 6.2],
      [4, 136, 7.1],
      [4, 137, 7.5],
      [4, 138, 9.4],
      [4, 139, 8.7],
      [4, 140, 9.5],
      [4, 141, 12.1],
      [4, 142, 9.5],
      [4, 143, 9.3],
      [4, 144, 8.5],
      [4, 145, 8.0],
      [4, 146, 9.8],
      [4, 147, 6.2],
      [4, 148, 7.3],
      [4, 149, 10.9],
      [4, 150, 10.0],
      [4, 151, 8.7],
      [4, 152, 9.0],
      [4, 153, 10.8],
      [4, 154, 12.4],
      [4, 155, 7.2],
      [4, 156, 7.2],
      [4, 157, 11.1],
      [4, 158, 9.3],
      [4, 159, 10.1],
      [4, 160, 3.9],
      [4, 161, 5.0],
      [4, 162, 8.2],
      [4, 163, 2.8],
      [4, 164, 4.3],
      [4, 165, 8.1],
      [4, 166, 11.1],
      [4, 167, 4.7],
      [4, 168, 5.3],
      [4, 169, 10.0],
      [4, 170, 5.6],
      [4, 171, 2.2],
      [4, 172, 7.1],
      [4, 173, 8.3],
      [4, 174, 8.6],
      [4, 175, 10.1],
      [4, 176, 8.3],
      [4, 177, 7.2],
      [4, 178, 7.7],
      [4, 179, 7.8],
      [4, 180, 9.1],
      [4, 181, 9.4],
      [4, 182, 7.8],
      [4, 183, 2.6],
      [4, 184, 2.4],
      [4, 185, 3.9],
      [4, 186, 1.3],
      [4, 187, 2.1],
      [4, 188, 7.4],
      [4, 189, 7.2],
      [4, 190, 8.8],
      [4, 191, 8.9],
      [4, 192, 8.8],
      [4, 193, 8.0],
      [4, 194, 0.7],
      [4, 195, 0.1],
      [4, 196, 0.9],
      [4, 197, 7.8],
      [4, 198, 7.2],
      [4, 199, 8.0],
      [4, 200, 4.6],
      [4, 201, 5.2],
      [4, 202, 5.8],
      [4, 203, 6.8],
      [4, 204, 8.1],
      [4, 205, 7.5],
      [4, 206, 5.4],
      [4, 207, 4.6],
      [4, 208, 6.4],
      [4, 209, 9.7],
      [4, 210, 7.0],
      [4, 211, 10.0],
      [4, 212, 10.6],
      [4, 213, 11.5],
      [4, 214, 10.2],
      [4, 215, 11.1],
      [4, 216, 11.0],
      [4, 217, 8.9],
      [4, 218, 9.9],
      [4, 219, 11.7],
      [4, 220, 11.6],
      [4, 221, 9.0],
      [4, 222, 6.3],
      [4, 223, 8.7],
      [4, 224, 8.5],
      [4, 225, 8.5],
      [4, 226, 8.0],
      [4, 227, 6.0],
      [4, 228, 8.0],
      [4, 229, 8.5],
      [4, 230, 7.7],
      [4, 231, 8.4],
      [4, 232, 9.0],
      [4, 233, 8.3],
      [4, 234, 6.8],
      [4, 235, 9.3],
      [4, 236, 6.7],
      [4, 237, 9.0],
      [4, 238, 7.3],
      [4, 239, 6.3],
      [4, 240, 7.9],
      [4, 241, 5.2],
      [4, 242, 9.0],
      [4, 243, 11.3],
      [4, 244, 9.2],
      [4, 245, 11.3],
      [4, 246, 7.0],
      [4, 247, 8.0],
      [4, 248, 4.6],
      [4, 249, 8.5],
      [4, 250, 9.5],
      [4, 251, 9.4],
      [4, 252, 10.5],
      [4, 253, 9.7],
      [4, 254, 4.9],
      [4, 255, 8.0],
      [4, 256, 5.8],
      [4, 257, 5.5],
      [4, 258, 10.9],
      [4, 259, 11.7],
      [4, 260, 9.2],
      [4, 261, 8.9],
      [4, 262, 11.3],
      [4, 263, 8.6],
      [4, 264, 6.2],
      [4, 265, 6.6],
      [4, 266, 9.1],
      [4, 267, 6.1],
      [4, 268, 7.5],
      [4, 269, 10.7],
      [4, 270, 6.3],
      [4, 271, 5.5],
      [4, 272, 6.7],
      [4, 273, 4.2],
      [4, 274, 11.3],
      [4, 275, 16.3],
      [4, 276, 10.5],
      [4, 277, 10.3],
      [4, 278, 7.9],
      [4, 279, 7.7],
      [4, 280, 16.0],
      [4, 281, 14.6],
      [4, 282, 12.5],
      [4, 283, 8.1],
      [4, 284, 12.2],
      [4, 285, 17.2],
      [4, 286, 9.4],
      [4, 287, 8.7],
      [4, 288, 5.9],
      [4, 289, 4.8],
      [4, 290, 7.4],
      [4, 291, 9.4],
      [4, 292, 9.7],
      [4, 293, 9.9],
      [4, 294, 6.5],
      [4, 295, 9.8],
      [4, 296, 18.2],
      [4, 297, 11.3],
      [4, 298, 9.1],
      [4, 299, 9.6],
      [4, 300, 13.5],
      [4, 301, 10.7],
      [4, 302, 10.0],
      [4, 303, 8.5],
      [4, 304, 12.6],
      [4, 305, 16.6],
      [4, 306, 11.6],
      [4, 307, 12.2],
      [4, 308, 11.2],
      [4, 309, 9.2],
      [4, 310, 9.9],
      [4, 311, 11.9],
      [4, 312, 15.6],
      [4, 313, 19.0],
      [4, 314, 12.8],
      [4, 315, 12.2],
      [4, 316, 12.0],
      [4, 317, 11.1],
      [4, 318, 11.8],
      [4, 319, 7.6],
      [4, 320, 13.0],
      [4, 321, 12.7],
      [4, 322, 16.0],
      [4, 323, 14.8],
      [4, 324, 14.2],
      [4, 325, 10.0],
      [4, 326, 8.8],
      [4, 327, 11.6],
      [4, 328, 8.6],
      [4, 329, 14.6],
      [4, 330, 24.3],
      [4, 331, 11.6],
      [4, 332, 10.8],
      [4, 333, 12.0],
      [4, 334, 11.0],
      [4, 335, 12.6],
      [4, 336, 10.8],
      [4, 337, 9.1],
      [4, 338, 11.0],
      [4, 339, 13.0],
      [4, 340, 12.8],
      [4, 341, 9.9],
      [4, 342, 11.6],
      [4, 343, 10.5],
      [4, 344, 15.9],
      [4, 345, 12.2],
      [4, 346, 13.0],
      [4, 347, 12.5],
      [4, 348, 12.5],
      [4, 349, 11.4],
      [4, 350, 12.1],
      [4, 351, 16.8],
      [4, 352, 12.1],
      [4, 353, 11.3],
      [4, 354, 10.4],
      [4, 355, 14.2],
      [4, 356, 11.4],
      [4, 357, 13.7],
      [4, 358, 16.5],
      [4, 359, 12.8],
      [4, 360, 12.2],
      [4, 361, 12.0],
      [4, 362, 12.6],
      [4, 363, 16.0],
      [4, 364, 16.4],
      [5, 1, 13.3],
      [5, 2, 15.2],
      [5, 3, 13.1],
      [5, 4, 12.7],
      [5, 5, 14.6],
      [5, 6, 11.0],
      [5, 7, 13.2],
      [5, 8, 12.2],
      [5, 9, 14.4],
      [5, 10, 13.7],
      [5, 11, 14.5],
      [5, 12, 14.1],
      [5, 13, 14.4],
      [5, 14, 19.7],
      [5, 15, 16.5],
      [5, 16, 15.9],
      [5, 17, 11.8],
      [5, 18, 12.0],
      [5, 19, 11.4],
      [5, 20, 14.4],
      [5, 21, 12.4],
      [5, 22, 15.1],
      [5, 23, 15.6],
      [5, 24, 15.2],
      [5, 25, 12.8],
      [5, 26, 13.3],
      [5, 27, 17.5],
      [5, 28, 15.4],
      [5, 29, 13.5],
      [5, 30, 16.7],
      [5, 31, 15.2],
      [5, 32, 14.9],
      [5, 33, 10.2],
      [5, 34, 13.6],
      [5, 35, 19.0],
      [5, 36, 15.7],
      [5, 37, 18.0],
      [5, 38, 14.8],
      [5, 39, 13.9],
      [5, 40, 13.0],
      [5, 41, 15.3],
      [5, 42, 14.3],
      [5, 43, 15.6],
      [5, 44, 16.0],
      [5, 45, 14.9],
      [5, 46, 11.1],
      [5, 47, 14.8],
      [5, 48, 13.0],
      [5, 49, 12.2],
      [5, 50, 10.9],
      [5, 51, 14.6],
      [5, 52, 16.6],
      [5, 53, 18.1],
      [5, 54, 13.4],
      [5, 55, 10.3],
      [5, 56, 13.6],
      [5, 57, 13.8],
      [5, 58, 10.3],
      [5, 59, 11.0],
      [5, 60, 14.3],
      [5, 61, 15.5],
      [5, 62, 14.7],
      [5, 63, 12.7],
      [5, 64, 10.7],
      [5, 65, 12.6],
      [5, 66, 9.8],
      [5, 67, 13.2],
      [5, 68, 15.2],
      [5, 69, 16.6],
      [5, 70, 21.0],
      [5, 71, 22.4],
      [5, 72, 17.0],
      [5, 73, 21.7],
      [5, 74, 21.4],
      [5, 75, 18.6],
      [5, 76, 16.2],
      [5, 77, 16.8],
      [5, 78, 17.0],
      [5, 79, 18.4],
      [5, 80, 17.2],
      [5, 81, 18.4],
      [5, 82, 18.8],
      [5, 83, 16.5],
      [5, 84, 13.3],
      [5, 85, 12.2],
      [5, 86, 11.3],
      [5, 87, 13.8],
      [5, 88, 16.6],
      [5, 89, 14.0],
      [5, 90, 14.3],
      [5, 91, 16.4],
      [5, 92, 11.9],
      [5, 93, 15.7],
      [5, 94, 17.6],
      [5, 95, 17.5],
      [5, 96, 15.9],
      [5, 97, 16.2],
      [5, 98, 16.0],
      [5, 99, 15.9],
      [5, 100, 16.2],
      [5, 101, 16.2],
      [5, 102, 19.5],
      [5, 103, 18.2],
      [5, 104, 21.8],
      [5, 105, 15.1],
      [5, 106, 11.0],
      [5, 107, 8.1],
      [5, 108, 9.5],
      [5, 109, 9.3],
      [5, 110, 10.6],
      [5, 111, 6.3],
      [5, 112, 8.6],
      [5, 113, 6.8],
      [5, 114, 8.7],
      [5, 115, 8.4],
      [5, 116, 9.3],
      [5, 117, 10.0],
      [5, 118, 10.5],
      [5, 119, 12.0],
      [5, 120, 10.1],
      [5, 121, 9.4],
      [5, 122, 10.1],
      [5, 123, 8.0],
      [5, 124, 10.6],
      [5, 125, 13.6],
      [5, 126, 15.4],
      [5, 127, 9.0],
      [5, 128, 10.4],
      [5, 129, 11.0],
      [5, 130, 12.1],
      [5, 131, 13.4],
      [5, 132, 11.3],
      [5, 133, 6.7],
      [5, 134, 9.8],
      [5, 135, 10.8],
      [5, 136, 7.8],
      [5, 137, 4.5],
      [5, 138, 7.6],
      [5, 139, 6.9],
      [5, 140, 7.5],
      [5, 141, 8.5],
      [5, 142, 5.5],
      [5, 143, 9.5],
      [5, 144, 7.3],
      [5, 145, 5.4],
      [5, 146, 5.5],
      [5, 147, 8.1],
      [5, 148, 11.2],
      [5, 149, 13.4],
      [5, 150, 11.6],
      [5, 151, 10.1],
      [5, 152, 4.3],
      [5, 153, 5.5],
      [5, 154, 4.4],
      [5, 155, 5.9],
      [5, 156, 5.7],
      [5, 157, 8.2],
      [5, 158, 8.2],
      [5, 159, 4.2],
      [5, 160, 6.5],
      [5, 161, 10.0],
      [5, 162, 8.8],
      [5, 163, 6.6],
      [5, 164, 7.8],
      [5, 165, 10.1],
      [5, 166, 7.1],
      [5, 167, 7.7],
      [5, 168, 8.5],
      [5, 169, 7.3],
      [5, 170, 6.9],
      [5, 171, 8.4],
      [5, 172, 7.1],
      [5, 173, 6.3],
      [5, 174, 0.6],
      [5, 175, 1.6],
      [5, 176, 7.0],
      [5, 177, 8.3],
      [5, 178, 8.0],
      [5, 179, 10.2],
      [5, 180, 10.6],
      [5, 181, 10.4],
      [5, 182, 11.6],
      [5, 183, 11.0],
      [5, 184, 10.7],
      [5, 185, 7.3],
      [5, 186, 4.2],
      [5, 187, 4.7],
      [5, 188, 5.6],
      [5, 189, 7.7],
      [5, 190, 7.5],
      [5, 191, 4.9],
      [5, 192, 5.9],
      [5, 193, 7.8],
      [5, 194, 5.8],
      [5, 195, 7.0],
      [5, 196, 8.4],
      [5, 197, 6.2],
      [5, 198, 7.5],
      [5, 199, 4.8],
      [5, 200, 3.3],
      [5, 201, 3.2],
      [5, 202, 7.0],
      [5, 203, 8.4],
      [5, 204, 0.3],
      [5, 205, 0.3],
      [5, 206, 2.1],
      [5, 207, 8.5],
      [5, 208, 1.4],
      [5, 209, 4.1],
      [5, 210, 10.3],
      [5, 211, 6.6],
      [5, 212, 6.1],
      [5, 213, 7.0],
      [5, 214, 5.1],
      [5, 215, 6.3],
      [5, 216, 6.9],
      [5, 217, 11.4],
      [5, 218, 10.4],
      [5, 219, 10.3],
      [5, 220, 9.2],
      [5, 221, 7.2],
      [5, 222, 7.5],
      [5, 223, 4.0],
      [5, 224, 5.6],
      [5, 225, 6.7],
      [5, 226, 8.4],
      [5, 227, 11.0],
      [5, 228, 8.4],
      [5, 229, 8.8],
      [5, 230, 8.6],
      [5, 231, 8.3],
      [5, 232, 4.0],
      [5, 233, 3.6],
      [5, 234, 5.7],
      [5, 235, 10.6],
      [5, 236, 6.9],
      [5, 237, 10.0],
      [5, 238, 9.8],
      [5, 239, 7.2],
      [5, 240, 10.5],
      [5, 241, 3.6],
      [5, 242, 5.3],
      [5, 243, 8.4],
      [5, 244, 10.3],
      [5, 245, 7.9],
      [5, 246, 8.5],
      [5, 247, 7.9],
      [5, 248, 8.0],
      [5, 249, 9.8],
      [5, 250, 6.7],
      [5, 251, 4.8],
      [5, 252, 9.9],
      [5, 253, 12.8],
      [5, 254, 10.9],
      [5, 255, 11.7],
      [5, 256, 11.7],
      [5, 257, 11.0],
      [5, 258, 8.2],
      [5, 259, 7.5],
      [5, 260, 5.4],
      [5, 261, 7.2],
      [5, 262, 9.7],
      [5, 263, 8.4],
      [5, 264, 9.0],
      [5, 265, 8.7],
      [5, 266, 6.6],
      [5, 267, 11.6],
      [5, 268, 13.1],
      [5, 269, 6.7],
      [5, 270, 6.5],
      [5, 271, 7.7],
      [5, 272, 8.7],
      [5, 273, 7.2],
      [5, 274, 10.5],
      [5, 275, 8.6],
      [5, 276, 7.2],
      [5, 277, 11.4],
      [5, 278, 16.2],
      [5, 279, 6.1],
      [5, 280, 9.6],
      [5, 281, 11.1],
      [5, 282, 13.6],
      [5, 283, 10.7],
      [5, 284, 14.7],
      [5, 285, 11.6],
      [5, 286, 7.3],
      [5, 287, 8.0],
      [5, 288, 9.6],
      [5, 289, 16.0],
      [5, 290, 15.1],
      [5, 291, 12.8],
      [5, 292, 6.2],
      [5, 293, 7.1],
      [5, 294, 8.4],
      [5, 295, 10.0],
      [5, 296, 12.7],
      [5, 297, 10.0],
      [5, 298, 10.2],
      [5, 299, 6.5],
      [5, 300, 9.2],
      [5, 301, 11.9],
      [5, 302, 14.7],
      [5, 303, 11.4],
      [5, 304, 6.8],
      [5, 305, 7.4],
      [5, 306, 11.2],
      [5, 307, 9.2],
      [5, 308, 12.6],
      [5, 309, 16.0],
      [5, 310, 17.1],
      [5, 311, 15.3],
      [5, 312, 13.3],
      [5, 313, 15.4],
      [5, 314, 13.2],
      [5, 315, 14.4],
      [5, 316, 14.0],
      [5, 317, 15.5],
      [5, 318, 21.0],
      [5, 319, 10.0],
      [5, 320, 9.6],
      [5, 321, 12.0],
      [5, 322, 12.2],
      [5, 323, 11.3],
      [5, 324, 13.2],
      [5, 325, 10.5],
      [5, 326, 10.1],
      [5, 327, 8.8],
      [5, 328, 13.7],
      [5, 329, 16.2],
      [5, 330, 16.0],
      [5, 331, 14.0],
      [5, 332, 13.7],
      [5, 333, 12.5],
      [5, 334, 12.8],
      [5, 335, 12.3],
      [5, 336, 15.2],
      [5, 337, 15.0],
      [5, 338, 16.4],
      [5, 339, 16.1],
      [5, 340, 14.6],
      [5, 341, 18.2],
      [5, 342, 16.4],
      [5, 343, 16.6],
      [5, 344, 14.7],
      [5, 345, 15.8],
      [5, 346, 14.1],
      [5, 347, 13.5],
      [5, 348, 13.6],
      [5, 349, 13.7],
      [5, 350, 13.6],
      [5, 351, 12.1],
      [5, 352, 12.7],
      [5, 353, 13.3],
      [5, 354, 14.2],
      [5, 355, 15.0],
      [5, 356, 13.7],
      [5, 357, 12.0],
      [5, 358, 13.1],
      [5, 359, 13.2],
      [5, 360, 13.3],
      [5, 361, 11.5],
      [5, 362, 10.8],
      [5, 363, 12.0],
      [5, 364, 16.3],
      [5, 365, 14.4],
      [6, 1, 12.9],
      [6, 2, 13.8],
      [6, 3, 10.6],
      [6, 4, 12.6],
      [6, 5, 13.7],
      [6, 6, 12.6],
      [6, 7, 13.1],
      [6, 8, 15.4],
      [6, 9, 11.9],
      [6, 10, 13.8],
      [6, 11, 14.4],
      [6, 12, 15.2],
      [6, 13, 12.5],
      [6, 14, 12.2],
      [6, 15, 16.1],
      [6, 16, 14.6],
      [6, 17, 11.6],
      [6, 18, 13.1],
      [6, 19, 12.8],
      [6, 20, 15.2],
      [6, 21, 13.8],
      [6, 22, 15.0],
      [6, 23, 13.5],
      [6, 24, 11.8],
      [6, 25, 15.3],
      [6, 26, 13.5],
      [6, 27, 15.3],
      [6, 28, 13.8],
      [6, 29, 15.8],
      [6, 30, 17.4],
      [6, 31, 15.3],
      [6, 32, 14.6],
      [6, 33, 14.8],
      [6, 34, 10.7],
      [6, 35, 11.6],
      [6, 36, 13.6],
      [6, 37, 14.4],
      [6, 38, 11.8],
      [6, 39, 15.8],
      [6, 40, 16.0],
      [6, 41, 11.8],
      [6, 42, 14.5],
      [6, 43, 10.7],
      [6, 44, 14.2],
      [6, 45, 19.5],
      [6, 46, 21.4],
      [6, 47, 17.9],
      [6, 48, 17.4],
      [6, 49, 12.7],
      [6, 50, 13.8],
      [6, 51, 14.0],
      [6, 52, 15.0],
      [6, 53, 14.5],
      [6, 54, 13.1],
      [6, 55, 11.4],
      [6, 56, 12.5],
      [6, 57, 12.0],
      [6, 58, 13.4],
      [6, 59, 14.4],
      [6, 60, 17.7],
      [6, 61, 13.9],
      [6, 62, 13.3],
      [6, 63, 14.6],
      [6, 64, 16.4],
      [6, 65, 16.8],
      [6, 66, 20.0],
      [6, 67, 12.5],
      [6, 68, 12.7],
      [6, 69, 11.7],
      [6, 70, 12.7],
      [6, 71, 8.6],
      [6, 72, 11.9],
      [6, 73, 16.0],
      [6, 74, 15.2],
      [6, 75, 13.4],
      [6, 76, 11.6],
      [6, 77, 11.1],
      [6, 78, 15.6],
      [6, 79, 17.0],
      [6, 80, 18.5],
      [6, 81, 17.4],
      [6, 82, 16.5],
      [6, 83, 16.2],
      [6, 84, 16.1],
      [6, 85, 13.2],
      [6, 86, 18.0],
      [6, 87, 12.8],
      [6, 88, 11.7],
      [6, 89, 16.7],
      [6, 90, 15.6],
      [6, 91, 10.2],
      [6, 92, 10.3],
      [6, 93, 15.0],
      [6, 94, 18.0],
      [6, 95, 13.8],
      [6, 96, 10.5],
      [6, 97, 11.8],
      [6, 98, 7.2],
      [6, 99, 11.6],
      [6, 100, 7.4],
      [6, 101, 14.2],
      [6, 102, 12.2],
      [6, 103, 9.0],
      [6, 104, 12.3],
      [6, 105, 19.7],
      [6, 106, 12.8],
      [6, 107, 12.4],
      [6, 108, 12.0],
      [6, 109, 12.0],
      [6, 110, 11.1],
      [6, 111, 12.7],
      [6, 112, 14.2],
      [6, 113, 11.6],
      [6, 114, 12.0],
      [6, 115, 11.5],
      [6, 116, 8.3],
      [6, 117, 10.5],
      [6, 118, 9.0],
      [6, 119, 6.9],
      [6, 120, 9.4],
      [6, 121, 11.1],
      [6, 122, 9.1],
      [6, 123, 7.7],
      [6, 124, 10.0],
      [6, 125, 10.4],
      [6, 126, 8.0],
      [6, 127, 9.8],
      [6, 128, 12.4],
      [6, 129, 12.9],
      [6, 130, 12.3],
      [6, 131, 6.9],
      [6, 132, 10.5],
      [6, 133, 11.0],
      [6, 134, 9.7],
      [6, 135, 11.1],
      [6, 136, 11.5],
      [6, 137, 13.4],
      [6, 138, 10.9],
      [6, 139, 12.0],
      [6, 140, 12.1],
      [6, 141, 10.4],
      [6, 142, 10.0],
      [6, 143, 9.6],
      [6, 144, 11.3],
      [6, 145, 8.5],
      [6, 146, 6.3],
      [6, 147, 8.2],
      [6, 148, 10.7],
      [6, 149, 10.3],
      [6, 150, 9.5],
      [6, 151, 10.9],
      [6, 152, 10.9],
      [6, 153, 4.3],
      [6, 154, 5.2],
      [6, 155, 11.0],
      [6, 156, 11.6],
      [6, 157, 10.6],
      [6, 158, 9.4],
      [6, 159, 10.0],
      [6, 160, 9.6],
      [6, 161, 9.5],
      [6, 162, 9.7],
      [6, 163, 9.6],
      [6, 164, 7.0],
      [6, 165, 7.0],
      [6, 166, 6.8],
      [6, 167, 6.9],
      [6, 168, 8.0],
      [6, 169, 7.6],
      [6, 170, 8.6],
      [6, 171, 5.7],
      [6, 172, 5.5],
      [6, 173, 5.7],
      [6, 174, 5.7],
      [6, 175, 6.6],
      [6, 176, 6.0],
      [6, 177, 6.9],
      [6, 178, 7.7],
      [6, 179, 8.0],
      [6, 180, 3.9],
      [6, 181, 0.8],
      [6, 182, 2.8],
      [6, 183, 8.0],
      [6, 184, 9.8],
      [6, 185, 11.4],
      [6, 186, 8.6],
      [6, 187, 5.2],
      [6, 188, 6.6],
      [6, 189, 5.7],
      [6, 190, 4.6],
      [6, 191, 5.8],
      [6, 192, 7.0],
      [6, 193, 4.8],
      [6, 194, 4.4],
      [6, 195, 4.4],
      [6, 196, 7.9],
      [6, 197, 10.6],
      [6, 198, 5.0],
      [6, 199, 7.6],
      [6, 200, 9.2],
      [6, 201, 9.7],
      [6, 202, 8.8],
      [6, 203, 6.8],
      [6, 204, 9.4],
      [6, 205, 11.0],
      [6, 206, 2.5],
      [6, 207, 2.1],
      [6, 208, 5.4],
      [6, 209, 6.2],
      [6, 210, 7.8],
      [6, 211, 7.4],
      [6, 212, 9.3],
      [6, 213, 9.3],
      [6, 214, 9.5],
      [6, 215, 8.5],
      [6, 216, 10.0],
      [6, 217, 7.7],
      [6, 218, 9.3],
      [6, 219, 9.1],
      [6, 220, 3.5],
      [6, 221, 3.6],
      [6, 222, 2.5],
      [6, 223, 1.7],
      [6, 224, 2.7],
      [6, 225, 2.9],
      [6, 226, 5.3],
      [6, 227, 7.7],
      [6, 228, 9.1],
      [6, 229, 9.4],
      [6, 230, 7.3],
      [6, 231, 8.4],
      [6, 232, 9.2],
      [6, 233, 6.6],
      [6, 234, 9.7],
      [6, 235, 12.4],
      [6, 236, 10.2],
      [6, 237, 5.9],
      [6, 238, 7.1],
      [6, 239, 7.5],
      [6, 240, 9.7],
      [6, 241, 12.2],
      [6, 242, 5.6],
      [6, 243, 5.4],
      [6, 244, 8.3],
      [6, 245, 10.6],
      [6, 246, 9.1],
      [6, 247, 11.3],
      [6, 248, 10.9],
      [6, 249, 8.9],
      [6, 250, 6.3],
      [6, 251, 9.0],
      [6, 252, 6.1],
      [6, 253, 9.1],
      [6, 254, 9.6],
      [6, 255, 6.0],
      [6, 256, 10.0],
      [6, 257, 11.0],
      [6, 258, 6.2],
      [6, 259, 8.3],
      [6, 260, 11.3],
      [6, 261, 11.3],
      [6, 262, 6.7],
      [6, 263, 6.6],
      [6, 264, 11.4],
      [6, 265, 6.9],
      [6, 266, 10.6],
      [6, 267, 8.6],
      [6, 268, 11.3],
      [6, 269, 12.5],
      [6, 270, 9.9],
      [6, 271, 6.9],
      [6, 272, 5.5],
      [6, 273, 7.8],
      [6, 274, 11.0],
      [6, 275, 16.2],
      [6, 276, 9.9],
      [6, 277, 8.7],
      [6, 278, 10.5],
      [6, 279, 12.2],
      [6, 280, 10.6],
      [6, 281, 8.3],
      [6, 282, 5.5],
      [6, 283, 9.0],
      [6, 284, 6.4],
      [6, 285, 7.2],
      [6, 286, 12.9],
      [6, 287, 12.0],
      [6, 288, 7.3],
      [6, 289, 9.7],
      [6, 290, 8.4],
      [6, 291, 14.7],
      [6, 292, 9.5],
      [6, 293, 7.9],
      [6, 294, 6.8],
      [6, 295, 12.6],
      [6, 296, 5.2],
      [6, 297, 7.5],
      [6, 298, 8.7],
      [6, 299, 7.6],
      [6, 300, 9.0],
      [6, 301, 7.2],
      [6, 302, 10.7],
      [6, 303, 13.1],
      [6, 304, 13.9],
      [6, 305, 10.8],
      [6, 306, 10.4],
      [6, 307, 9.1],
      [6, 308, 16.0],
      [6, 309, 21.0],
      [6, 310, 16.2],
      [6, 311, 8.6],
      [6, 312, 9.2],
      [6, 313, 12.5],
      [6, 314, 9.7],
      [6, 315, 12.5],
      [6, 316, 10.3],
      [6, 317, 12.0],
      [6, 318, 11.0],
      [6, 319, 14.8],
      [6, 320, 15.0],
      [6, 321, 15.3],
      [6, 322, 10.3],
      [6, 323, 10.7],
      [6, 324, 10.5],
      [6, 325, 8.9],
      [6, 326, 8.1],
      [6, 327, 11.5],
      [6, 328, 12.8],
      [6, 329, 9.1],
      [6, 330, 14.6],
      [6, 331, 11.6],
      [6, 332, 11.2],
      [6, 333, 12.6],
      [6, 334, 7.5],
      [6, 335, 11.0],
      [6, 336, 14.5],
      [6, 337, 18.5],
      [6, 338, 15.4],
      [6, 339, 13.1],
      [6, 340, 16.3],
      [6, 341, 20.2],
      [6, 342, 11.5],
      [6, 343, 12.4],
      [6, 344, 10.9],
      [6, 345, 12.7],
      [6, 346, 12.2],
      [6, 347, 12.4],
      [6, 348, 9.8],
      [6, 349, 8.5],
      [6, 350, 14.7],
      [6, 351, 12.0],
      [6, 352, 10.3],
      [6, 353, 11.0],
      [6, 354, 10.2],
      [6, 355, 12.6],
      [6, 356, 11.6],
      [6, 357, 9.7],
      [6, 358, 13.4],
      [6, 359, 10.5],
      [6, 360, 14.7],
      [6, 361, 14.6],
      [6, 362, 14.2],
      [6, 363, 13.2],
      [6, 364, 11.7],
      [6, 365, 17.2],
      [7, 1, 12.3],
      [7, 2, 13.8],
      [7, 3, 15.3],
      [7, 4, 15.6],
      [7, 5, 16.2],
      [7, 6, 16.3],
      [7, 7, 16.8],
      [7, 8, 11.0],
      [7, 9, 8.5],
      [7, 10, 13.2],
      [7, 11, 13.0],
      [7, 12, 12.4],
      [7, 13, 13.0],
      [7, 14, 16.6],
      [7, 15, 12.0],
      [7, 16, 12.4],
      [7, 17, 15.0],
      [7, 18, 11.8],
      [7, 19, 11.6],
      [7, 20, 12.2],
      [7, 21, 13.7],
      [7, 22, 11.2],
      [7, 23, 12.4],
      [7, 24, 11.5],
      [7, 25, 13.8],
      [7, 26, 15.7],
      [7, 27, 12.9],
      [7, 28, 11.5],
      [7, 29, 11.0],
      [7, 30, 12.7],
      [7, 31, 14.9],
      [7, 32, 16.5],
      [7, 33, 12.8],
      [7, 34, 12.7],
      [7, 35, 12.7],
      [7, 36, 11.6],
      [7, 37, 13.3],
      [7, 38, 15.2],
      [7, 39, 16.4],
      [7, 40, 11.9],
      [7, 41, 15.1],
      [7, 42, 10.6],
      [7, 43, 13.6],
      [7, 44, 12.1],
      [7, 45, 16.0],
      [7, 46, 16.8],
      [7, 47, 16.6],
      [7, 48, 15.6],
      [7, 49, 15.2],
      [7, 50, 17.7],
      [7, 51, 21.0],
      [7, 52, 13.4],
      [7, 53, 10.5],
      [7, 54, 9.5],
      [7, 55, 12.0],
      [7, 56, 10.4],
      [7, 57, 11.5],
      [7, 58, 13.2],
      [7, 59, 15.0],
      [7, 60, 14.1],
      [7, 61, 12.4],
      [7, 62, 13.4],
      [7, 63, 12.5],
      [7, 64, 14.3],
      [7, 65, 17.6],
      [7, 66, 10.4],
      [7, 67, 9.9],
      [7, 68, 10.2],
      [7, 69, 11.3],
      [7, 70, 9.5],
      [7, 71, 11.8],
      [7, 72, 11.5],
      [7, 73, 10.5],
      [7, 74, 10.8],
      [7, 75, 13.0],
      [7, 76, 18.5],
      [7, 77, 18.7],
      [7, 78, 15.0],
      [7, 79, 13.0],
      [7, 80, 11.3],
      [7, 81, 13.0],
      [7, 82, 13.3],
      [7, 83, 11.0],
      [7, 84, 10.3],
      [7, 85, 13.0],
      [7, 86, 12.3],
      [7, 87, 15.6],
      [7, 88, 10.2],
      [7, 89, 10.8],
      [7, 90, 12.0],
      [7, 91, 13.3],
      [7, 92, 11.7],
      [7, 93, 12.5],
      [7, 94, 13.7],
      [7, 95, 14.9],
      [7, 96, 20.2],
      [7, 97, 16.3],
      [7, 98, 13.9],
      [7, 99, 10.1],
      [7, 100, 7.3],
      [7, 101, 14.0],
      [7, 102, 17.7],
      [7, 103, 16.3],
      [7, 104, 10.6],
      [7, 105, 9.7],
      [7, 106, 7.8],
      [7, 107, 10.4],
      [7, 108, 10.4],
      [7, 109, 14.1],
      [7, 110, 7.1],
      [7, 111, 8.1],
      [7, 112, 7.8],
      [7, 113, 10.6],
      [7, 114, 9.1],
      [7, 115, 9.0],
      [7, 116, 11.9],
      [7, 117, 17.1],
      [7, 118, 16.8],
      [7, 119, 13.5],
      [7, 120, 11.6],
      [7, 121, 7.0],
      [7, 122, 9.7],
      [7, 123, 9.9],
      [7, 124, 11.2],
      [7, 125, 11.3],
      [7, 126, 11.8],
      [7, 127, 9.9],
      [7, 128, 7.1],
      [7, 129, 9.6],
      [7, 130, 9.8],
      [7, 131, 10.6],
      [7, 132, 12.8],
      [7, 133, 16.5],
      [7, 134, 11.7],
      [7, 135, 12.3],
      [7, 136, 12.2],
      [7, 137, 11.8],
      [7, 138, 10.7],
      [7, 139, 10.2],
      [7, 140, 10.0],
      [7, 141, 8.3],
      [7, 142, 6.6],
      [7, 143, 9.5],
      [7, 144, 12.3],
      [7, 145, 7.6],
      [7, 146, 9.3],
      [7, 147, 5.0],
      [7, 148, 4.3],
      [7, 149, 6.4],
      [7, 150, 10.8],
      [7, 151, 7.8],
      [7, 152, 8.5],
      [7, 153, 9.7],
      [7, 154, 10.0],
      [7, 155, 11.0],
      [7, 156, 10.2],
      [7, 157, 6.6],
      [7, 158, 6.1],
      [7, 159, 5.9],
      [7, 160, 8.9],
      [7, 161, 13.0],
      [7, 162, 12.6],
      [7, 163, 5.4],
      [7, 164, 6.0],
      [7, 165, 7.8],
      [7, 166, 9.0],
      [7, 167, 4.2],
      [7, 168, 3.0],
      [7, 169, 4.5],
      [7, 170, 6.2],
      [7, 171, 11.9],
      [7, 172, 11.8],
      [7, 173, 9.4],
      [7, 174, 9.6],
      [7, 175, 9.4],
      [7, 176, 7.0],
      [7, 177, 8.9],
      [7, 178, 9.3],
      [7, 179, 6.8],
      [7, 180, 7.5],
      [7, 181, 8.0],
      [7, 182, 8.3],
      [7, 183, 2.7],
      [7, 184, 3.9],
      [7, 185, 4.1],
      [7, 186, 5.0],
      [7, 187, 5.8],
      [7, 188, 4.4],
      [7, 189, 4.1],
      [7, 190, 5.8],
      [7, 191, 9.1],
      [7, 192, 7.9],
      [7, 193, 5.0],
      [7, 194, 2.8],
      [7, 195, 4.7],
      [7, 196, 8.9],
      [7, 197, 5.4],
      [7, 198, 7.1],
      [7, 199, 9.0],
      [7, 200, 9.4],
      [7, 201, 6.3],
      [7, 202, 7.0],
      [7, 203, 6.4],
      [7, 204, 6.7],
      [7, 205, 1.5],
      [7, 206, 2.9],
      [7, 207, 4.8],
      [7, 208, 6.3],
      [7, 209, 5.7],
      [7, 210, 7.0],
      [7, 211, 8.8],
      [7, 212, 8.7],
      [7, 213, 9.0],
      [7, 214, 9.6],
      [7, 215, 8.0],
      [7, 216, 8.4],
      [7, 217, 8.1],
      [7, 218, 9.0],
      [7, 219, 5.3],
      [7, 220, 8.9],
      [7, 221, 8.7],
      [7, 222, 4.9],
      [7, 223, 7.0],
      [7, 224, 7.5],
      [7, 225, 7.0],
      [7, 226, 9.1],
      [7, 227, 11.8],
      [7, 228, 9.9],
      [7, 229, 5.6],
      [7, 230, 4.2],
      [7, 231, 4.3],
      [7, 232, 8.0],
      [7, 233, 5.1],
      [7, 234, 9.4],
      [7, 235, 9.1],
      [7, 236, 9.7],
      [7, 237, 10.6],
      [7, 238, 8.6],
      [7, 239, 10.1],
      [7, 240, 11.0],
      [7, 241, 9.7],
      [7, 242, 5.0],
      [7, 243, 6.1],
      [7, 244, 5.4],
      [7, 245, 5.8],
      [7, 246, 7.3],
      [7, 247, 6.3],
      [7, 248, 4.8],
      [7, 249, 7.6],
      [7, 250, 8.1],
      [7, 251, 9.5],
      [7, 252, 10.3],
      [7, 253, 7.0],
      [7, 254, 9.0],
      [7, 255, 10.2],
      [7, 256, 6.8],
      [7, 257, 9.3],
      [7, 258, 9.8],
      [7, 259, 10.7],
      [7, 260, 7.8],
      [7, 261, 9.2],
      [7, 262, 15.0],
      [7, 263, 7.8],
      [7, 264, 5.3],
      [7, 265, 9.5],
      [7, 266, 7.6],
      [7, 267, 14.0],
      [7, 268, 14.9],
      [7, 269, 14.9],
      [7, 270, 19.2],
      [7, 271, 17.0],
      [7, 272, 13.0],
      [7, 273, 11.2],
      [7, 274, 9.5],
      [7, 275, 10.3],
      [7, 276, 9.3],
      [7, 277, 11.3],
      [7, 278, 6.5],
      [7, 279, 12.0],
      [7, 280, 8.3],
      [7, 281, 8.7],
      [7, 282, 8.7],
      [7, 283, 10.2],
      [7, 284, 6.9],
      [7, 285, 4.9],
      [7, 286, 10.0],
      [7, 287, 7.6],
      [7, 288, 14.5],
      [7, 289, 13.2],
      [7, 290, 9.9],
      [7, 291, 10.1],
      [7, 292, 11.3],
      [7, 293, 10.4],
      [7, 294, 10.9],
      [7, 295, 9.2],
      [7, 296, 10.5],
      [7, 297, 11.4],
      [7, 298, 13.5],
      [7, 299, 9.8],
      [7, 300, 13.1],
      [7, 301, 9.7],
      [7, 302, 11.4],
      [7, 303, 9.9],
      [7, 304, 14.4],
      [7, 305, 19.0],
      [7, 306, 23.0],
      [7, 307, 15.4],
      [7, 308, 9.6],
      [7, 309, 10.8],
      [7, 310, 12.1],
      [7, 311, 11.0],
      [7, 312, 12.6],
      [7, 313, 14.7],
      [7, 314, 11.1],
      [7, 315, 10.1],
      [7, 316, 11.4],
      [7, 317, 13.0],
      [7, 318, 11.9],
      [7, 319, 9.5],
      [7, 320, 13.5],
      [7, 321, 15.2],
      [7, 322, 18.4],
      [7, 323, 24.1],
      [7, 324, 14.1],
      [7, 325, 10.7],
      [7, 326, 8.7],
      [7, 327, 13.3],
      [7, 328, 11.6],
      [7, 329, 9.9],
      [7, 330, 10.8],
      [7, 331, 11.5],
      [7, 332, 10.0],
      [7, 333, 13.9],
      [7, 334, 13.6],
      [7, 335, 11.9],
      [7, 336, 11.1],
      [7, 337, 8.2],
      [7, 338, 9.4],
      [7, 339, 12.7],
      [7, 340, 11.6],
      [7, 341, 11.0],
      [7, 342, 11.3],
      [7, 343, 13.4],
      [7, 344, 14.9],
      [7, 345, 15.2],
      [7, 346, 13.9],
      [7, 347, 15.0],
      [7, 348, 16.2],
      [7, 349, 17.7],
      [7, 350, 20.5],
      [7, 351, 14.7],
      [7, 352, 12.5],
      [7, 353, 10.9],
      [7, 354, 12.8],
      [7, 355, 12.7],
      [7, 356, 11.2],
      [7, 357, 11.4],
      [7, 358, 11.2],
      [7, 359, 12.1],
      [7, 360, 12.7],
      [7, 361, 16.2],
      [7, 362, 14.2],
      [7, 363, 14.3],
      [7, 364, 13.3],
      [7, 365, 16.7],
      [8, 1, 15.3],
      [8, 2, 14.3],
      [8, 3, 13.5],
      [8, 4, 15.0],
      [8, 5, 13.6],
      [8, 6, 15.2],
      [8, 7, 17.0],
      [8, 8, 18.7],
      [8, 9, 16.5],
      [8, 10, 17.4],
      [8, 11, 18.3],
      [8, 12, 18.3],
      [8, 13, 22.4],
      [8, 14, 21.4],
      [8, 15, 20.9],
      [8, 16, 17.6],
      [8, 17, 15.5],
      [8, 18, 16.6],
      [8, 19, 16.2],
      [8, 20, 15.6],
      [8, 21, 14.5],
      [8, 22, 14.0],
      [8, 23, 15.6],
      [8, 24, 12.3],
      [8, 25, 11.6],
      [8, 26, 12.6],
      [8, 27, 14.9],
      [8, 28, 17.3],
      [8, 29, 21.4],
      [8, 30, 23.4],
      [8, 31, 14.4],
      [8, 32, 14.1],
      [8, 33, 15.0],
      [8, 34, 14.5],
      [8, 35, 15.1],
      [8, 36, 13.9],
      [8, 37, 13.4],
      [8, 38, 9.2],
      [8, 39, 12.5],
      [8, 40, 15.1],
      [8, 41, 12.1],
      [8, 42, 14.5],
      [8, 43, 16.3],
      [8, 44, 16.5],
      [8, 45, 14.9],
      [8, 46, 13.2],
      [8, 47, 11.8],
      [8, 48, 13.6],
      [8, 49, 16.2],
      [8, 50, 14.1],
      [8, 51, 13.5],
      [8, 52, 15.0],
      [8, 53, 14.8],
      [8, 54, 16.2],
      [8, 55, 16.2],
      [8, 56, 13.3],
      [8, 57, 15.3],
      [8, 58, 18.4],
      [8, 59, 16.2],
      [8, 60, 12.4],
      [8, 61, 15.6],
      [8, 62, 14.9],
      [8, 63, 14.8],
      [8, 64, 12.7],
      [8, 65, 14.2],
      [8, 66, 16.8],
      [8, 67, 16.7],
      [8, 68, 16.2],
      [8, 69, 14.5],
      [8, 70, 10.0],
      [8, 71, 12.6],
      [8, 72, 11.9],
      [8, 73, 11.8],
      [8, 74, 13.4],
      [8, 75, 14.5],
      [8, 76, 15.7],
      [8, 77, 15.3],
      [8, 78, 13.9],
      [8, 79, 13.7],
      [8, 80, 15.1],
      [8, 81, 15.6],
      [8, 82, 14.4],
      [8, 83, 13.9],
      [8, 84, 16.2],
      [8, 85, 16.7],
      [8, 86, 15.5],
      [8, 87, 16.4],
      [8, 88, 17.5],
      [8, 89, 18.2],
      [8, 90, 16.1],
      [8, 91, 16.5],
      [8, 92, 14.6],
      [8, 93, 16.4],
      [8, 94, 13.6],
      [8, 95, 15.9],
      [8, 96, 11.9],
      [8, 97, 14.7],
      [8, 98, 9.4],
      [8, 99, 6.6],
      [8, 100, 7.9],
      [8, 101, 11.0],
      [8, 102, 15.7],
      [8, 103, 15.2],
      [8, 104, 15.9],
      [8, 105, 10.6],
      [8, 106, 8.3],
      [8, 107, 8.6],
      [8, 108, 12.7],
      [8, 109, 10.5],
      [8, 110, 12.0],
      [8, 111, 11.1],
      [8, 112, 13.0],
      [8, 113, 12.4],
      [8, 114, 13.3],
      [8, 115, 15.9],
      [8, 116, 12.0],
      [8, 117, 13.7],
      [8, 118, 17.6],
      [8, 119, 14.3],
      [8, 120, 13.7],
      [8, 121, 15.2],
      [8, 122, 14.5],
      [8, 123, 14.9],
      [8, 124, 15.5],
      [8, 125, 16.4],
      [8, 126, 14.5],
      [8, 127, 12.6],
      [8, 128, 13.6],
      [8, 129, 11.2],
      [8, 130, 11.0],
      [8, 131, 12.0],
      [8, 132, 6.8],
      [8, 133, 10.6],
      [8, 134, 13.1],
      [8, 135, 13.5],
      [8, 136, 11.7],
      [8, 137, 13.2],
      [8, 138, 12.0],
      [8, 139, 10.4],
      [8, 140, 10.0],
      [8, 141, 8.2],
      [8, 142, 9.4],
      [8, 143, 10.3],
      [8, 144, 8.1],
      [8, 145, 8.7],
      [8, 146, 12.6],
      [8, 147, 10.9],
      [8, 148, 8.7],
      [8, 149, 9.3],
      [8, 150, 6.3],
      [8, 151, 7.8],
      [8, 152, 10.0],
      [8, 153, 11.0],
      [8, 154, 11.1],
      [8, 155, 12.6],
      [8, 156, 10.2],
      [8, 157, 11.1],
      [8, 158, 8.7],
      [8, 159, 9.5],
      [8, 160, 9.7],
      [8, 161, 8.2],
      [8, 162, 5.0],
      [8, 163, 6.5],
      [8, 164, 12.1],
      [8, 165, 8.9],
      [8, 166, 6.1],
      [8, 167, 2.8],
      [8, 168, 3.7],
      [8, 169, 6.8],
      [8, 170, 6.6],
      [8, 171, 7.0],
      [8, 172, 7.3],
      [8, 173, 7.9],
      [8, 174, 10.6],
      [8, 175, 8.1],
      [8, 176, 6.7],
      [8, 177, 8.0],
      [8, 178, 10.0],
      [8, 179, 6.7],
      [8, 180, 9.4],
      [8, 181, 9.3],
      [8, 182, 6.0],
      [8, 183, 5.8],
      [8, 184, 4.9],
      [8, 185, 5.0],
      [8, 186, 8.4],
      [8, 187, 12.3],
      [8, 188, 13.0],
      [8, 189, 11.4],
      [8, 190, 6.8],
      [8, 191, 7.6],
      [8, 192, 12.4],
      [8, 193, 7.1],
      [8, 194, 7.5],
      [8, 195, 10.0],
      [8, 196, 5.3],
      [8, 197, 6.3],
      [8, 198, 8.0],
      [8, 199, 8.3],
      [8, 200, 9.3],
      [8, 201, 9.5],
      [8, 202, 5.6],
      [8, 203, 7.0],
      [8, 204, 8.5],
      [8, 205, 8.5],
      [8, 206, 8.2],
      [8, 207, 8.5],
      [8, 208, 9.6],
      [8, 209, 9.7],
      [8, 210, 7.1],
      [8, 211, 8.4],
      [8, 212, 9.2],
      [8, 213, 9.8],
      [8, 214, 8.1],
      [8, 215, 9.4],
      [8, 216, 10.0],
      [8, 217, 5.1],
      [8, 218, 6.7],
      [8, 219, 6.9],
      [8, 220, 6.8],
      [8, 221, 8.6],
      [8, 222, 9.1],
      [8, 223, 3.9],
      [8, 224, 4.8],
      [8, 225, 8.4],
      [8, 226, 11.6],
      [8, 227, 12.1],
      [8, 228, 12.4],
      [8, 229, 10.0],
      [8, 230, 10.1],
      [8, 231, 9.7],
      [8, 232, 11.7],
      [8, 233, 7.9],
      [8, 234, 8.6],
      [8, 235, 7.7],
      [8, 236, 5.8],
      [8, 237, 8.7],
      [8, 238, 10.6],
      [8, 239, 6.7],
      [8, 240, 8.8],
      [8, 241, 9.7],
      [8, 242, 9.0],
      [8, 243, 11.8],
      [8, 244, 15.2],
      [8, 245, 10.0],
      [8, 246, 10.5],
      [8, 247, 5.5],
      [8, 248, 9.4],
      [8, 249, 8.8],
      [8, 250, 5.3],
      [8, 251, 13.0],
      [8, 252, 15.2],
      [8, 253, 13.2],
      [8, 254, 11.5],
      [8, 255, 6.8],
      [8, 256, 4.7],
      [8, 257, 5.2],
      [8, 258, 6.8],
      [8, 259, 10.7],
      [8, 260, 10.1],
      [8, 261, 10.0],
      [8, 262, 9.8],
      [8, 263, 5.5],
      [8, 264, 13.5],
      [8, 265, 16.6],
      [8, 266, 8.4],
      [8, 267, 8.2],
      [8, 268, 11.1],
      [8, 269, 10.8],
      [8, 270, 8.8],
      [8, 271, 10.8],
      [8, 272, 8.7],
      [8, 273, 12.4],
      [8, 274, 9.0],
      [8, 275, 13.5],
      [8, 276, 14.7],
      [8, 277, 10.9],
      [8, 278, 8.5],
      [8, 279, 6.0],
      [8, 280, 12.7],
      [8, 281, 11.1],
      [8, 282, 8.7],
      [8, 283, 12.3],
      [8, 284, 13.3],
      [8, 285, 5.6],
      [8, 286, 13.7],
      [8, 287, 8.5],
      [8, 288, 11.2],
      [8, 289, 8.7],
      [8, 290, 11.7],
      [8, 291, 12.5],
      [8, 292, 8.2],
      [8, 293, 15.6],
      [8, 294, 10.3],
      [8, 295, 11.4],
      [8, 296, 9.7],
      [8, 297, 6.3],
      [8, 298, 14.3],
      [8, 299, 11.3],
      [8, 300, 7.3],
      [8, 301, 12.8],
      [8, 302, 11.9],
      [8, 303, 14.3],
      [8, 304, 11.6],
      [8, 305, 13.2],
      [8, 306, 15.5],
      [8, 307, 14.1],
      [8, 308, 9.5],
      [8, 309, 7.2],
      [8, 310, 11.8],
      [8, 311, 16.8],
      [8, 312, 12.5],
      [8, 313, 9.4],
      [8, 314, 11.9],
      [8, 315, 10.3],
      [8, 316, 16.9],
      [8, 317, 17.5],
      [8, 318, 7.5],
      [8, 319, 8.6],
      [8, 320, 11.1],
      [8, 321, 11.5],
      [8, 322, 10.7],
      [8, 323, 15.7],
      [8, 324, 12.8],
      [8, 325, 13.0],
      [8, 326, 12.9],
      [8, 327, 14.3],
      [8, 328, 13.7],
      [8, 329, 12.1],
      [8, 330, 11.9],
      [8, 331, 11.8],
      [8, 332, 11.4],
      [8, 333, 10.3],
      [8, 334, 11.7],
      [8, 335, 12.0],
      [8, 336, 17.4],
      [8, 337, 16.8],
      [8, 338, 16.2],
      [8, 339, 13.0],
      [8, 340, 12.5],
      [8, 341, 12.4],
      [8, 342, 16.1],
      [8, 343, 20.2],
      [8, 344, 14.3],
      [8, 345, 11.0],
      [8, 346, 14.4],
      [8, 347, 15.7],
      [8, 348, 19.7],
      [8, 349, 20.7],
      [8, 350, 23.9],
      [8, 351, 16.6],
      [8, 352, 17.5],
      [8, 353, 14.9],
      [8, 354, 13.6],
      [8, 355, 11.9],
      [8, 356, 15.2],
      [8, 357, 17.3],
      [8, 358, 19.8],
      [8, 359, 15.8],
      [8, 360, 9.5],
      [8, 361, 12.9],
      [8, 362, 12.9],
      [8, 363, 14.8],
      [8, 364, 14.1],
      [9, 1, 14.3],
      [9, 2, 17.4],
      [9, 3, 18.5],
      [9, 4, 16.8],
      [9, 5, 11.5],
      [9, 6, 9.5],
      [9, 7, 12.2],
      [9, 8, 15.7],
      [9, 9, 16.3],
      [9, 10, 13.6],
      [9, 11, 12.6],
      [9, 12, 13.8],
      [9, 13, 12.1],
      [9, 14, 13.4],
      [9, 15, 17.3],
      [9, 16, 19.4],
      [9, 17, 16.6],
      [9, 18, 13.9],
      [9, 19, 13.1],
      [9, 20, 16.0],
      [9, 21, 14.5],
      [9, 22, 15.0],
      [9, 23, 12.6],
      [9, 24, 12.5],
      [9, 25, 15.2],
      [9, 26, 16.2],
      [9, 27, 16.5],
      [9, 28, 20.1],
      [9, 29, 20.6],
      [9, 30, 16.9],
      [9, 31, 16.5],
      [9, 32, 16.1],
      [9, 33, 14.4],
      [9, 34, 16.3],
      [9, 35, 15.7],
      [9, 36, 14.2],
      [9, 37, 13.2],
      [9, 38, 16.8],
      [9, 39, 18.5],
      [9, 40, 16.7],
      [9, 41, 15.3],
      [9, 42, 15.9],
      [9, 43, 15.2],
      [9, 44, 17.5],
      [9, 45, 18.3],
      [9, 46, 19.4],
      [9, 47, 19.4],
      [9, 48, 19.5],
      [9, 49, 20.5],
      [9, 50, 15.7],
      [9, 51, 15.0],
      [9, 52, 16.1],
      [9, 53, 14.3],
      [9, 54, 13.0],
      [9, 55, 16.2],
      [9, 56, 17.7],
      [9, 57, 13.2],
      [9, 58, 15.8],
      [9, 59, 18.5],
      [9, 60, 20.4],
      [9, 61, 22.0],
      [9, 62, 19.7],
      [9, 63, 19.6],
      [9, 64, 20.3],
      [9, 65, 18.3],
      [9, 66, 18.9],
      [9, 67, 20.3],
      [9, 68, 21.4],
      [9, 69, 18.3],
      [9, 70, 17.8],
      [9, 71, 17.7],
      [9, 72, 12.8],
      [9, 73, 15.1],
      [9, 74, 15.0],
      [9, 75, 14.8],
      [9, 76, 12.0],
      [9, 77, 12.5],
      [9, 78, 15.0],
      [9, 79, 17.1],
      [9, 80, 17.3],
      [9, 81, 16.9],
      [9, 82, 16.5],
      [9, 83, 13.6],
      [9, 84, 13.2],
      [9, 85, 9.4],
      [9, 86, 9.5],
      [9, 87, 11.8],
      [9, 88, 10.4],
      [9, 89, 9.7],
      [9, 90, 12.6],
      [9, 91, 13.3],
      [9, 92, 15.1],
      [9, 93, 14.2],
      [9, 94, 14.2],
      [9, 95, 19.2],
      [9, 96, 12.6],
      [9, 97, 14.2],
      [9, 98, 11.9],
      [9, 99, 13.9],
      [9, 100, 13.5],
      [9, 101, 15.3],
      [9, 102, 13.9],
      [9, 103, 14.0],
      [9, 104, 12.9],
      [9, 105, 8.5],
      [9, 106, 11.4],
      [9, 107, 10.9],
      [9, 108, 12.0],
      [9, 109, 8.6],
      [9, 110, 9.0],
      [9, 111, 9.6],
      [9, 112, 10.2],
      [9, 113, 9.8],
      [9, 114, 8.3],
      [9, 115, 11.0],
      [9, 116, 11.9],
      [9, 117, 14.0],
      [9, 118, 15.8],
      [9, 119, 14.5],
      [9, 120, 13.2],
      [9, 121, 14.2],
      [9, 122, 14.6],
      [9, 123, 11.8],
      [9, 124, 14.4],
      [9, 125, 10.4],
      [9, 126, 10.3],
      [9, 127, 10.8],
      [9, 128, 10.5],
      [9, 129, 9.5],
      [9, 130, 12.5],
      [9, 131, 13.7],
      [9, 132, 12.7],
      [9, 133, 11.9],
      [9, 134, 11.4],
      [9, 135, 9.7],
      [9, 136, 8.3],
      [9, 137, 8.1],
      [9, 138, 11.7],
      [9, 139, 11.6],
      [9, 140, 7.4],
      [9, 141, 5.2],
      [9, 142, 11.0],
      [9, 143, 9.5],
      [9, 144, 9.2],
      [9, 145, 10.7],
      [9, 146, 9.0],
      [9, 147, 10.2],
      [9, 148, 10.3],
      [9, 149, 12.1],
      [9, 150, 13.2],
      [9, 151, 6.6],
      [9, 152, 2.3],
      [9, 153, 1.4],
      [9, 154, 2.1],
      [9, 155, 6.6],
      [9, 156, 8.9],
      [9, 157, 7.8],
      [9, 158, 9.0],
      [9, 159, 10.3],
      [9, 160, 7.9],
      [9, 161, 7.2],
      [9, 162, 8.6],
      [9, 163, 8.8],
      [9, 164, 6.2],
      [9, 165, 9.5],
      [9, 166, 10.2],
      [9, 167, 9.7],
      [9, 168, 11.2],
      [9, 169, 10.2],
      [9, 170, 10.1],
      [9, 171, 8.1],
      [9, 172, 6.6],
      [9, 173, 5.0],
      [9, 174, 4.7],
      [9, 175, 5.3],
      [9, 176, 4.5],
      [9, 177, 2.3],
      [9, 178, 1.4],
      [9, 179, 0.5],
      [9, 180, 2.4],
      [9, 181, 8.0],
      [9, 182, 6.0],
      [9, 183, 7.1],
      [9, 184, 9.7],
      [9, 185, 6.9],
      [9, 186, 5.3],
      [9, 187, 7.0],
      [9, 188, 6.2],
      [9, 189, 7.0],
      [9, 190, 9.7],
      [9, 191, 8.0],
      [9, 192, 8.5],
      [9, 193, 7.1],
      [9, 194, 7.5],
      [9, 195, 3.3],
      [9, 196, 1.8],
      [9, 197, 2.6],
      [9, 198, 5.3],
      [9, 199, 5.8],
      [9, 200, 5.8],
      [9, 201, 7.2],
      [9, 202, 5.3],
      [9, 203, 1.6],
      [9, 204, 3.1],
      [9, 205, 5.3],
      [9, 206, 7.7],
      [9, 207, 4.2],
      [9, 208, 5.5],
      [9, 209, 9.0],
      [9, 210, 11.2],
      [9, 211, 8.0],
      [9, 212, 7.6],
      [9, 213, 3.7],
      [9, 214, 7.5],
      [9, 215, 8.1],
      [9, 216, 8.4],
      [9, 217, 7.1],
      [9, 218, 7.6],
      [9, 219, 7.6],
      [9, 220, 5.6],
      [9, 221, 7.0],
      [9, 222, 10.5],
      [9, 223, 7.3],
      [9, 224, 7.8],
      [9, 225, 5.8],
      [9, 226, 3.8],
      [9, 227, 5.8],
      [9, 228, 6.7],
      [9, 229, 6.6],
      [9, 230, 6.6],
      [9, 231, 9.0],
      [9, 232, 8.1],
      [9, 233, 5.1],
      [9, 234, 8.6],
      [9, 235, 7.0],
      [9, 236, 5.5],
      [9, 237, 7.4],
      [9, 238, 6.2],
      [9, 239, 4.2],
      [9, 240, 6.3],
      [9, 241, 7.0],
      [9, 242, 4.0],
      [9, 243, 8.0],
      [9, 244, 8.8],
      [9, 245, 8.8],
      [9, 246, 6.1],
      [9, 247, 8.6],
      [9, 248, 8.9],
      [9, 249, 7.8],
      [9, 250, 5.0],
      [9, 251, 7.0],
      [9, 252, 13.3],
      [9, 253, 7.9],
      [9, 254, 7.5],
      [9, 255, 8.3],
      [9, 256, 7.2],
      [9, 257, 6.5],
      [9, 258, 8.9],
      [9, 259, 7.4],
      [9, 260, 9.9],
      [9, 261, 9.3],
      [9, 262, 10.6],
      [9, 263, 8.6],
      [9, 264, 7.2],
      [9, 265, 12.6],
      [9, 266, 7.8],
      [9, 267, 6.3],
      [9, 268, 9.2],
      [9, 269, 5.8],
      [9, 270, 9.0],
      [9, 271, 5.0],
      [9, 272, 11.9],
      [9, 273, 13.4],
      [9, 274, 10.5],
      [9, 275, 6.2],
      [9, 276, 5.1],
      [9, 277, 9.5],
      [9, 278, 11.7],
      [9, 279, 9.2],
      [9, 280, 7.3],
      [9, 281, 9.7],
      [9, 282, 9.4],
      [9, 283, 10.0],
      [9, 284, 10.9],
      [9, 285, 11.0],
      [9, 286, 10.9],
      [9, 287, 8.0],
      [9, 288, 11.2],
      [9, 289, 7.5],
      [9, 290, 7.2],
      [9, 291, 13.2],
      [9, 292, 12.9],
      [9, 293, 9.4],
      [9, 294, 10.2],
      [9, 295, 9.5],
      [9, 296, 12.4],
      [9, 297, 10.2],
      [9, 298, 13.4],
      [9, 299, 11.6],
      [9, 300, 8.0],
      [9, 301, 9.0],
      [9, 302, 9.3],
      [9, 303, 13.5],
      [9, 304, 8.0],
      [9, 305, 8.1],
      [9, 306, 10.0],
      [9, 307, 8.5],
      [9, 308, 12.5],
      [9, 309, 15.0],
      [9, 310, 13.3],
      [9, 311, 11.0],
      [9, 312, 11.9],
      [9, 313, 8.3],
      [9, 314, 9.7],
      [9, 315, 11.3],
      [9, 316, 12.5],
      [9, 317, 9.4],
      [9, 318, 11.4],
      [9, 319, 13.2],
      [9, 320, 13.8],
      [9, 321, 16.0],
      [9, 322, 10.9],
      [9, 323, 11.9],
      [9, 324, 12.4],
      [9, 325, 13.2],
      [9, 326, 15.5],
      [9, 327, 21.6],
      [9, 328, 14.9],
      [9, 329, 14.4],
      [9, 330, 12.9],
      [9, 331, 13.1],
      [9, 332, 14.0],
      [9, 333, 17.9],
      [9, 334, 17.7],
      [9, 335, 16.3],
      [9, 336, 18.3],
      [9, 337, 13.7],
      [9, 338, 13.3],
      [9, 339, 10.6],
      [9, 340, 14.1],
      [9, 341, 16.0],
      [9, 342, 16.5],
      [9, 343, 14.1],
      [9, 344, 18.7],
      [9, 345, 16.2],
      [9, 346, 14.8],
      [9, 347, 12.6],
      [9, 348, 10.4],
      [9, 349, 12.2],
      [9, 350, 12.6],
      [9, 351, 12.1],
      [9, 352, 17.3],
      [9, 353, 16.4],
      [9, 354, 12.6],
      [9, 355, 12.3],
      [9, 356, 11.8],
      [9, 357, 12.0],
      [9, 358, 12.7],
      [9, 359, 16.4],
      [9, 360, 16.0],
      [9, 361, 13.3],
      [9, 362, 11.7],
      [9, 363, 10.4],
      [9, 364, 14.4],
      [9, 365, 12.7],
      [10, 1, 14.8],
      [10, 2, 13.3],
      [10, 3, 15.6],
      [10, 4, 14.5],
      [10, 5, 14.3],
      [10, 6, 15.3],
      [10, 7, 16.4],
      [10, 8, 14.8],
      [10, 9, 17.4],
      [10, 10, 18.8],
      [10, 11, 22.1],
      [10, 12, 19.0],
      [10, 13, 15.5],
      [10, 14, 15.8],
      [10, 15, 14.7],
      [10, 16, 10.7],
      [10, 17, 11.5],
      [10, 18, 15.0],
      [10, 19, 14.5],
      [10, 20, 14.5],
      [10, 21, 13.3],
      [10, 22, 14.3],
      [10, 23, 14.3],
      [10, 24, 20.5],
      [10, 25, 15.0],
      [10, 26, 17.1],
      [10, 27, 16.9],
      [10, 28, 16.9],
      [10, 29, 13.6],
      [10, 30, 16.4],
      [10, 31, 16.1],
      [10, 32, 12.0],
      [10, 33, 12.2],
      [10, 34, 14.8],
      [10, 35, 14.8],
      [10, 36, 14.4],
      [10, 37, 12.9],
      [10, 38, 13.4],
      [10, 39, 15.9],
      [10, 40, 16.1],
      [10, 41, 17.6],
      [10, 42, 15.6],
      [10, 43, 15.0],
      [10, 44, 13.0],
      [10, 45, 14.1],
      [10, 46, 17.3],
      [10, 47, 15.7],
      [10, 48, 18.6],
      [10, 49, 12.7],
      [10, 50, 14.0],
      [10, 51, 13.7],
      [10, 52, 16.3],
      [10, 53, 20.0],
      [10, 54, 17.0],
      [10, 55, 15.2],
      [10, 56, 16.5],
      [10, 57, 16.5],
      [10, 58, 17.3],
      [10, 59, 19.1],
      [10, 60, 19.3],
      [10, 61, 17.3],
      [10, 62, 19.0],
      [10, 63, 19.8],
      [10, 64, 19.3],
      [10, 65, 17.2],
      [10, 66, 14.2],
      [10, 67, 10.3],
      [10, 68, 13.0],
      [10, 69, 15.3],
      [10, 70, 15.0],
      [10, 71, 12.1],
      [10, 72, 9.2],
      [10, 73, 11.0],
      [10, 74, 15.0],
      [10, 75, 11.6],
      [10, 76, 11.6],
      [10, 77, 15.1],
      [10, 78, 15.0],
      [10, 79, 13.6],
      [10, 80, 12.5],
      [10, 81, 14.3],
      [10, 82, 16.0],
      [10, 83, 17.4],
      [10, 84, 16.9],
      [10, 85, 18.0],
      [10, 86, 20.6],
      [10, 87, 14.2],
      [10, 88, 10.9],
      [10, 89, 11.9],
      [10, 90, 13.3],
      [10, 91, 15.3],
      [10, 92, 14.7],
      [10, 93, 11.0],
      [10, 94, 12.2],
      [10, 95, 14.2],
      [10, 96, 17.0],
      [10, 97, 15.8],
      [10, 98, 15.2],
      [10, 99, 15.1],
      [10, 100, 14.7],
      [10, 101, 18.5],
      [10, 102, 16.4],
      [10, 103, 18.4],
      [10, 104, 15.1],
      [10, 105, 9.9],
      [10, 106, 10.2],
      [10, 107, 12.6],
      [10, 108, 13.2],
      [10, 109, 11.5],
      [10, 110, 13.8],
      [10, 111, 14.5],
      [10, 112, 14.7],
      [10, 113, 11.2],
      [10, 114, 12.7],
      [10, 115, 13.7],
      [10, 116, 11.5],
      [10, 117, 10.4],
      [10, 118, 8.9],
      [10, 119, 11.1],
      [10, 120, 9.5],
      [10, 121, 13.0],
      [10, 122, 13.9],
      [10, 123, 12.6],
      [10, 124, 14.3],
      [10, 125, 16.0],
      [10, 126, 13.3],
      [10, 127, 7.0],
      [10, 128, 4.9],
      [10, 129, 6.9],
      [10, 130, 13.7],
      [10, 131, 10.6],
      [10, 132, 12.3],
      [10, 133, 11.1],
      [10, 134, 10.2],
      [10, 135, 9.5],
      [10, 136, 8.9],
      [10, 137, 13.4],
      [10, 138, 9.1],
      [10, 139, 9.4],
      [10, 140, 8.7],
      [10, 141, 5.8],
      [10, 142, 4.5],
      [10, 143, 7.2],
      [10, 144, 10.0],
      [10, 145, 10.5],
      [10, 146, 10.7],
      [10, 147, 8.2],
      [10, 148, 6.1],
      [10, 149, 4.5],
      [10, 150, 6.1],
      [10, 151, 9.8],
      [10, 152, 9.7],
      [10, 153, 8.2],
      [10, 154, 8.4],
      [10, 155, 8.5],
      [10, 156, 10.4],
      [10, 157, 6.8],
      [10, 158, 6.0],
      [10, 159, 6.6],
      [10, 160, 7.8],
      [10, 161, 10.3],
      [10, 162, 7.2],
      [10, 163, 7.4],
      [10, 164, 11.4],
      [10, 165, 5.4],
      [10, 166, 4.4],
      [10, 167, 6.4],
      [10, 168, 9.3],
      [10, 169, 7.7],
      [10, 170, 8.1],
      [10, 171, 8.3],
      [10, 172, 9.1],
      [10, 173, 7.7],
      [10, 174, 10.6],
      [10, 175, 8.2],
      [10, 176, 7.9],
      [10, 177, 5.2],
      [10, 178, 5.9],
      [10, 179, 3.7],
      [10, 180, 5.6],
      [10, 181, 9.4],
      [10, 182, 7.4],
      [10, 183, 7.3],
      [10, 184, 7.7],
      [10, 185, 7.7],
      [10, 186, 9.3],
      [10, 187, 4.4],
      [10, 188, 5.7],
      [10, 189, 10.2],
      [10, 190, 10.2],
      [10, 191, 9.3],
      [10, 192, 5.4],
      [10, 193, 5.0],
      [10, 194, 7.6],
      [10, 195, 9.6],
      [10, 196, 10.4],
      [10, 197, 11.2],
      [10, 198, 9.1],
      [10, 199, 11.2],
      [10, 200, 6.8],
      [10, 201, 8.3],
      [10, 202, 9.7],
      [10, 203, 9.6],
      [10, 204, 9.8],
      [10, 205, 10.8],
      [10, 206, 9.2],
      [10, 207, 6.5],
      [10, 208, 8.1],
      [10, 209, 7.3],
      [10, 210, 7.9],
      [10, 211, 6.0],
      [10, 212, 5.0],
      [10, 213, 6.8],
      [10, 214, 9.8],
      [10, 215, 5.7],
      [10, 216, 8.6],
      [10, 217, 10.6],
      [10, 218, 7.8],
      [10, 219, 7.7],
      [10, 220, 8.6],
      [10, 221, 6.5],
      [10, 222, 6.9],
      [10, 223, 6.4],
      [10, 224, 8.5],
      [10, 225, 7.8],
      [10, 226, 9.3],
      [10, 227, 8.4],
      [10, 228, 7.8],
      [10, 229, 7.4],
      [10, 230, 7.7],
      [10, 231, 8.9],
      [10, 232, 9.7],
      [10, 233, 9.9],
      [10, 234, 6.1],
      [10, 235, 6.6],
      [10, 236, 7.6],
      [10, 237, 7.4],
      [10, 238, 8.0],
      [10, 239, 2.1],
      [10, 240, 5.9],
      [10, 241, 11.6],
      [10, 242, 8.6],
      [10, 243, 7.9],
      [10, 244, 6.0],
      [10, 245, 9.5],
      [10, 246, 8.6],
      [10, 247, 7.6],
      [10, 248, 10.4],
      [10, 249, 10.3],
      [10, 250, 7.5],
      [10, 251, 3.0],
      [10, 252, 5.3],
      [10, 253, 10.5],
      [10, 254, 14.6],
      [10, 255, 12.6],
      [10, 256, 9.8],
      [10, 257, 7.2],
      [10, 258, 10.1],
      [10, 259, 10.4],
      [10, 260, 3.7],
      [10, 261, 7.3],
      [10, 262, 11.6],
      [10, 263, 16.3],
      [10, 264, 9.6],
      [10, 265, 6.8],
      [10, 266, 5.2],
      [10, 267, 10.6],
      [10, 268, 16.3],
      [10, 269, 9.8],
      [10, 270, 4.6],
      [10, 271, 11.1],
      [10, 272, 8.7],
      [10, 273, 10.0],
      [10, 274, 11.3],
      [10, 275, 10.5],
      [10, 276, 9.9],
      [10, 277, 11.0],
      [10, 278, 14.0],
      [10, 279, 9.2],
      [10, 280, 9.8],
      [10, 281, 6.0],
      [10, 282, 9.8],
      [10, 283, 9.2],
      [10, 284, 11.8],
      [10, 285, 10.3],
      [10, 286, 7.5],
      [10, 287, 7.7],
      [10, 288, 15.8],
      [10, 289, 14.6],
      [10, 290, 10.5],
      [10, 291, 11.3],
      [10, 292, 10.9],
      [10, 293, 6.4],
      [10, 294, 10.9],
      [10, 295, 9.0],
      [10, 296, 10.9],
      [10, 297, 12.4],
      [10, 298, 11.6],
      [10, 299, 13.3],
      [10, 300, 14.4],
      [10, 301, 18.4],
      [10, 302, 13.6],
      [10, 303, 14.9],
      [10, 304, 14.8],
      [10, 305, 15.4],
      [10, 306, 11.8],
      [10, 307, 13.0],
      [10, 308, 11.1],
      [10, 309, 12.5],
      [10, 310, 18.3],
      [10, 311, 19.2],
      [10, 312, 15.4],
      [10, 313, 13.1],
      [10, 314, 11.5],
      [10, 315, 8.6],
      [10, 316, 12.6],
      [10, 317, 13.8],
      [10, 318, 14.6],
      [10, 319, 13.2],
      [10, 320, 12.3],
      [10, 321, 8.8],
      [10, 322, 10.7],
      [10, 323, 9.9],
      [10, 324, 8.3],
      [10, 325, 15.0],
      [10, 326, 12.2],
      [10, 327, 10.5],
      [10, 328, 11.1],
      [10, 329, 13.0],
      [10, 330, 12.9],
      [10, 331, 8.8],
      [10, 332, 14.7],
      [10, 333, 14.7],
      [10, 334, 12.7],
      [10, 335, 13.3],
      [10, 336, 13.2],
      [10, 337, 16.2],
      [10, 338, 17.3],
      [10, 339, 20.5],
      [10, 340, 20.2],
      [10, 341, 19.4],
      [10, 342, 15.5],
      [10, 343, 14.1],
      [10, 344, 11.0],
      [10, 345, 11.1],
      [10, 346, 14.0],
      [10, 347, 11.4],
      [10, 348, 12.5],
      [10, 349, 13.4],
      [10, 350, 13.6],
      [10, 351, 13.9],
      [10, 352, 17.2],
      [10, 353, 14.7],
      [10, 354, 15.4],
      [10, 355, 13.1],
      [10, 356, 13.2],
      [10, 357, 13.9],
      [10, 358, 10.0],
      [10, 359, 12.9],
      [10, 360, 14.6],
      [10, 361, 14.0],
      [10, 362, 13.6],
      [10, 363, 13.5],
      [10, 364, 15.7],
      [10, 365, 13.0]]
    
    var option = null;
    ThreeDBar.setOption(option = {
        backgroundColor: '#1A2942',
        title: {
          text: '三维柱状图',
          left: 'center',
          textStyle: {
            color: "#358BA3" // 主标题文字的颜色
          }
        },
        visualMap: {
          min: 5,
          max: 25,
          show: false,
          inRange: {
            color: [
              '#313695',
              '#4575b4',
              '#74add1',
              '#abd9e9',
              '#e0f3f8',
              '#ffffbf',
              '#fee090',
              '#fdae61',
              '#f46d43',
              '#d73027',
              '#a50026'
            ]
          }
        },
      xAxis3D: {
        type: 'category',
        data: year,
        name: 'Year',
        nameTextStyle:{
          color:"#FFF", 
          fontSize:12,  
        },          
        axisLabel: {
          show: true,
          textStyle: {
            color: '#FFF'
          }
      }
      },
      yAxis3D: {
        type: 'category',
        data: date,
        name: 'Date',
        nameTextStyle:{
          color:"#FFF", 
          fontSize:12,  
        },          
        axisLabel: {
          show: true,
          textStyle: {
            color: '#FFF'
          }
      }
      },
      zAxis3D: {
        type: 'value',
        max: 30,
        min: 0,
        name: 'Temperature',
        nameTextStyle:{
          color:"#FFF", 
          fontSize:12,  
        },          
        axisLabel: {
          show: true,
          textStyle: {
            color: '#FFF'
          }
      }
      },
      grid3D: {
        boxWidth: 40,
        boxDepth: 160,
        axisLine: {
            lineStyle: {
              color: '#000'
            }
        },
        axisPointer: {
          lineStyle: {
            color: '#000'
          }
        },
        viewControl: {
          autoRotate: true
        }
      },
      series: [{
          type: 'bar3D',
          data: data,
          shading: 'lambert',
          label: {
            formatter: function (param) {
              return param.value[2].toFixed(1);
            }
          }
        }]
    });

    if (option && typeof option === "object") {
      ThreeDBar.setOption(option, true);
    }
  }, []);

  
  return (
    <div id="ThreeDBar" style={{ width: "100%", height: "100vh" }}></div>
  );
}